import { Component, OnInit } from "@angular/core";
import { FileToUpload } from "../file-upload/file-to-upload.model";
import { ApiMethod } from "../apimethods/api-method";
import { GlobalConstants } from "../common/global-constants";
import { ArticleinfoModel } from "./articleinfo-model";
import * as ngswal from "sweetalert";
import { customfunctions } from "../common/customfunctions";
declare var $;
@Component({
  selector: "app-articleinfo",
  templateUrl: "./articleinfo.component.html",
  styleUrls: ["./articleinfo.component.css"]
})

export class ArticleinfoComponent implements OnInit {
  static modelItem: ArticleinfoModel = new ArticleinfoModel();
  static articleId: number;
  static aartId: number;
  static aproofId: number;
  static awebLink: string;
  static jrnlCode: string;
  static articleNo: string;
  static aactivityId: string; static afileSno: string;
  static noNeedPDF: boolean;
  showNotesModal: boolean;
  showFileUpload: boolean;
  showHoldModal: boolean;
  static showRelease: boolean;
  showHoldHistoryModal: boolean;
  showCorrectionModal: boolean;
  showEPTCorrectionModal: boolean;
  showReviewModal: boolean;
  showCorr: boolean;
  showOndemandFirstRelease: boolean;
  showNotesHistoryModal: boolean;
  showArticleAction: boolean;
  static holdType: string;
  isHold: boolean;
  fileBase64: string = "";
  fileToUpload: File = null;
  fileCount: number = 0;
  filePath: any;
  files: string[] = [];
  public lAuthorList: any;
  public lLogList: any;
  public lReviewMail: any;
  articleNotes: string;
  static queryTypeList;
  static pasteHtmlTextClear = false;
  ArticleInfoAutoLoad: boolean = true;

  constructor() {
    ArticleinfoComponent.pasteHtmlTextClear = false;
    ApiMethod.getPageConfig().subscribe(
      data => {
        ArticleinfoComponent.modelItem = <ArticleinfoModel>data["ArticlePage"];
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });

  }
  public checkMetadataShow: boolean = GlobalConstants.CheckMetadataView('MetaData');
  public checkScheduleColumnShow: boolean = GlobalConstants.CheckMetadataView('ScheduleColumn');
  public checkRevisedScheduleColumnShow: boolean = GlobalConstants.CheckMetadataView('RevisedScheduleColumn');
  public checkOptionIncomplete: boolean = GlobalConstants.CheckMetadataView('OptionIncomplete');

  ngOnInit(): void {
    this.UpdateTableHeight();
    customfunctions.SetTodayDateValues("#Txt_DueDate");
    customfunctions.SetTodayDateValues("#Txt_HoldDueDate");

    setInterval(function () {
      if (this.ArticleInfoAutoLoad != false) {
        if (ArticleinfoComponent.articleId != null) {
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId, false, true);
        }
      }
    }, 10000);
  }

  ngAfterViewChecked(): void {
    this.UpdateTableHeight();
  }

  UpdateTableHeight() {
    $('#divWorkflow,#divFirstRelease,#divArticleLogList,#divArticleOldLogList').css('height', (GlobalConstants.size.height - 155));
    $('#divArticleFigureList,#divArticleGraphicsProcess,#divArticleXpressParseError').css('height', (GlobalConstants.size.height - 155));
    $('#divAddNotes,#divNotesHistory').css('height', (GlobalConstants.size.height - 400));
    $('#Divmail .jqte_editor ,#DivConfirmail .jqte_editor').css('height', (GlobalConstants.size.height - 330));
    $('#divPreviewMain,#divJrlNotesMain').css('height', (GlobalConstants.size.height) - 220);
  }

  public static ArticleInfo(id, downloadFile = false, autoLoad = false): void {

    if (!autoLoad) {
      $('#divLoading').show(); $('#divArtInfo').hide(); $("#tabOnDemand").css("display", "none"); $("#tabPrevLog").css("display", "none");
      $('a[href="#Article"]').click();

      $("#LoadingImagePopupInfo").show();

      $("#myModal_Review .select2").select2({ dropdownParent: "#myModal_Review" });
      $("#myModal_Corrections .select2").select2({ dropdownParent: "#myModal_Corrections" });
      $("#divAllocatePopup .select2").select2({ dropdownParent: "#divAllocatePopup" });
    }
    let _scheduleColumn = GlobalConstants.CheckMetadataView('ScheduleColumn');
    let _revisedScheduleColumn = GlobalConstants.CheckMetadataView('RevisedScheduleColumn');

    ArticleinfoComponent.articleId = id;
    var articleData = {
      ArticleId: id,
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.articleInfoByNoApi, articleData).subscribe(
      result => {
        $('#divLoadData').css('height', GlobalConstants.size.height - 100);
        let itemL = result.aArticleItem;
        let themName = localStorage.UserThemes;
        let userList = result.userList;
        let onFromVendor = result.aFromVendor;
        let onDemandDisable = result.aArticleFirstRelease;
        let xpressLog = result.xPressLog;

        //Check Article info available
        if (itemL != null) {

          //Disable Auto Refresh
          if (!autoLoad) {
            try {
              $("#ddlAllocateUser").empty();
              var selector = document.getElementById("ddlAllocateUser") as HTMLSelectElement;
              var newoption = document.createElement("option") as HTMLOptionElement;
              newoption.text = "Self Allocate";
              newoption.value = localStorage.aLoginID;
              selector.add(newoption);
              $.each(userList, function (e, val) {
                var selector = document.getElementById("ddlAllocateUser") as HTMLSelectElement;
                var newoption = document.createElement("option") as HTMLOptionElement;
                newoption.text = val.UserName;
                newoption.value = val.UserID;
                selector.add(newoption);
              });
            } catch (e) {
              console.log(e);
            }
          }
          let articleNo = "";
          let standardFR: boolean;
          let onDemandXML: boolean;
          let onDemandFromVendor: boolean = true;
          let onDemandRights = "";
          let holdReleaseRights = "";
          let firstProofQC = "";
          let approveArticleRights = "";
          let QCRights = "";
          let correctionRights = "";
          let finalCorrectionRights = "";
          let reviewRights = "";
          let egRights = "";
          let eptRights = "";
          let itemM = result.aMenuItem;
          let refUpload: boolean = false;
          let checkVolIssue: boolean = false;

          $.each(itemM, function (e, val) {

            if ((val.MenuID == "38") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              onDemandRights = "Yes";
            }
            if ((val.MenuID == "39") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              holdReleaseRights = "Yes";
            }
            //PM approval rights
            if ((val.MenuID == "40") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              approveArticleRights = "Yes";
            }
            //First proof QC rights
            if ((val.MenuID == "43") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              QCRights = "Yes";
            }
            //First proof correction rights
            if ((val.MenuID == "42") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              correctionRights = "Yes";
            }
            //Final correction rights
            if ((val.MenuID == "40") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              finalCorrectionRights = "Yes";
            }
            if ((val.MenuID == "41") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              reviewRights = "Yes";
            }
            if ((val.MenuID == "45") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              egRights = "Yes";
            }
            if ((val.MenuID == "46") && ((val.Action.includes('Add') == true) || (val.Action.includes('Update') == true))) {
              eptRights = "Yes";
            }
          });

          try {
            let firstReleaseCheck = GlobalConstants.isNullCheck(itemL[0].PubDateType).toLowerCase();
            firstReleaseCheck = firstReleaseCheck.replace('-', '').replace('_', '')
            if (firstReleaseCheck == "firstrelease") {
              standardFR = true;
              $("#tabOnDemand").css("display", "none");
              $("#FirstRelease").css("display", "none");
              $("#tabStandardFR").css("display", "");
              $("#StandardFirstRelease").css("display", "");
            }
            else {
              standardFR = false;
              $("#tabStandardFR").css("display", "none");
              $("#StandardFirstRelease").css("display", "none");
              if (onDemandRights == "Yes") {
                $("#tabOnDemand").css("display", "");
                $("#FirstRelease").css("display", "");
              }
              else {
                $("#tabOnDemand").css("display", "none");
                $("#FirstRelease").css("display", "none");
              }
            }
          }
          catch (e) {
            console.log(e);
          }

          if (itemL != null) {

            //Auto Refresh disable for Article data
            if (!autoLoad) {

              //Load ArticleInfo Popup dynamically
              let dynamicCol = result.dynamicColData;

              let ztable = customfunctions.DynamicHtmlDataBind(dynamicCol, itemL);
              $('.tblMain').html(ztable);
              if ($("#chkIsSpecialToNormal").length > 0) {
                let siTitle = $("#chkIsSpecialToNormal").attr('data-sititle');
                if (siTitle != '') {
                  $('#btnIsSpecialToNormal').trigger("click");
                }
              }
              //Load ArticleInfo Popup dynamically

              $('#Txt_HoldDueDate').val(GlobalConstants.SetValue_FormatDate(itemL[0].DueDate));
              ArticleinfoComponent.awebLink = itemL[0].PublWebLink;
              ArticleinfoComponent.jrnlCode = itemL[0].DoiJournalCode;
              ArticleinfoComponent.articleNo = itemL[0].ArticleNo;
              ArticleinfoComponent.noNeedPDF = itemL[0].NoNeedPDF;
              localStorage.articleData = itemL;
              articleNo = itemL[0].ArticleNo;

              $('[name="changeValue"]').change(function () {
                $('#txtVolume').val($("#TxtPopVolume").val());
                $('#txtIssue').val($("#TxtPopIssue").val());
              });

              if (itemL[0].IsApprove && !itemL[0].AlwaysEditMetadata) {
                $("#divArtInfo :input:not(:checkbox)").attr("disabled", true);
              }

              if (itemL[0].AlwaysEditMetadata) {
                localStorage.metadataEdit == true;
              }

              let itemAuthor = result.aProofingItem;

              $("#ddlMailTo").empty();
              $('#TxtMailTo').val('');
              try {

                var selector = document.getElementById("ddlMailTo") as HTMLSelectElement;
                $.each(itemAuthor, function (e, val) {

                  var newoption = document.createElement("option") as HTMLOptionElement;
                  /* newoption.text = (val.Given_names + ' ' + val.Surname);*/
                  newoption.text = (val.ProofToEmailId);
                  newoption.value = val.ProofToEmailId;
                  if (val.Corresp) {
                    //Corresp Author set default
                    //newoption.selected = true;
                    //$('#TxtMailTo').val(val.ProofToEmailId);
                  }
                  selector.add(newoption);
                });
                selector.value = "";
              } catch (e) {
                console.log(e);
              }

            }

            if (result.aReopenTran.length > 0) {
              onDemandXML = true;
            }
            else {
              onDemandXML = false;
            }


            let trSNo = 0;
            try {
              //Standard first release workflow details start
              $('#TblStandardFirstRelease tbody tr').remove();
              $('#divStandardFirstRelease').css('height', GlobalConstants.size.height - 180);
              let itemStandardWorkflow = result.aFirstReleaseWorkflowList;
              $.each(itemStandardWorkflow, function (e, val) {
                //ProjectPlan StandardFirstRelease SNo Allocate
                trSNo = (e + 1);
                let tr = '<tr >';
                tr += '<td>' + trSNo + '</td>';

                tr += '<td>' + val.Activity + '</td>';

                // ScheduleDate Column only for Metadatashow based
                if (_scheduleColumn) {
                  tr += '<td>' + GlobalConstants.FormatDate(val.ScheduleDate) + '</td>';
                }
                // RevisedScheduleDate Column only for Metadatashow based
                if (_revisedScheduleColumn) {
                  tr += '<td>' + GlobalConstants.FormatDate(val.RevisedScheduleDate) + '</td>';
                }

                tr += '<td>' + GlobalConstants.FormatDate(val.CompletedDate) + '</td>';

                let customAttr = 'data-proofId="' + val.ProofingID +
                  '" data-transId="' + val.ArtTransID +
                  '" data-transStatus="' + val.TransStatus +
                  '" data-activityId="' + val.ActivityID.toString() +
                  '" data-trsno="' + trSNo + '"';

                var workflowaction = "";
                if (val.EGOption == "ManualFR") {
                  workflowaction = '<span><i class="bx bx-user-check ManualFR" style="font-size:18px; color:#556ee6; " title="Allocate for manual pagination" ' + customAttr + '></i></span>&nbsp;';
                }
                if ((val.EGOption == "ManualFRPending") && (val.AllocatedUserIdFR == localStorage.aLoginID)) {
                  workflowaction = '<span><i class="bx bx-user-check ManualFRPendingReallocate" style="font-size:18px; color:darkyellow; " title="Allocate for manual pagination" ' + customAttr + '></i></span>&nbsp;<span><i class="bx bx-download ManualFRPending" style="font-size:18px; color:#556ee6; " title="Download XML for Pagination" ' + customAttr + '></i></span>&nbsp;';
                }
                if ((val.EGOption == "ManualFRPending") && (val.AllocatedUserIdFR != localStorage.aLoginID)) {
                  workflowaction = '<span><i class="bx bx-user-check ManualFRPendingReallocate" style="font-size:18px; color:darkyellow ; " title="Allocate for manual pagination" ' + customAttr + '></i></span>&nbsp;<span title="Allocated to user : ' + val.AllocateFRUserName + '">' + val.AllocateFRUserName + '</span>';
                }
                else if (val.Download != '0') {
                  if (val.Download != '0' && val.CompletedDate != null && val.Activity.indexOf('First Release Published') > 0) {
                    workflowaction = '<span><i class="bx bx-globe AtypeonStage" style = "font-size:18px; color:#556ee6; " title = "Web link"></i></span>';
                  }
                  workflowaction = workflowaction + '<i class="bx bx-download stageDownload" style="font-size:18px; color:#556ee6;" title="Download" ' + customAttr + '></i>&nbsp;';
                }

                tr += '<td class="dt-head-center">' + workflowaction + '</td>';

                tr += '</tr>';
                $('#TblStandardFirstRelease tbody').append(tr);
              });
              //Standard first release workflow details end

            } catch (e) {
              console.log(e);
            }

            try {
              let itemFirstRelease = result.aArticleFirstRelease;
              if (itemFirstRelease.length > 0) {
                $("#tabOnDemand").css("display", "");
                $("#FirstRelease").css("display", "");
              }
              else {
                $("#tabOnDemand").css("display", "none");
                $("#FirstRelease").css("display", "none");
              }

              $('#TblFirstRelease tbody tr').remove();
              $.each(itemFirstRelease, function (e, val) {
                //ProjectPlan StandardFirstRelease SNo Allocate

                let frth = ''; let frtr = '';

                if (val.Stage == 'Early First Release') {
                  //th data
                  frth += '<tr>';
                  frth += '<th>#</th>';
                  frth += '<th>Request Date</th>';
                  frth += '<th>NT Completion Date</th>';
                  frth += '<th>Highwire Publication Date</th>';
                  frth += '<th class="dt-head-center">Action</th>';
                  frth += '</tr>';
                  $('#TblFirstRelease thead').html(frth);

                  //tr data
                  trSNo = (e + 1);
                  frtr = '<tr>';
                  frtr += '<td>' + trSNo + '</td>';
                  frtr += '<td>' + GlobalConstants.FormatDate(val.RequestedDate) + '</td>';
                  frtr += '<td>' + GlobalConstants.FormatDate(val.PDFCreationDate) + '</td>';
                  frtr += '<td>' + GlobalConstants.FormatDate(val.UploadedDate) + '</td>';
                  let transId = GlobalConstants.isNaNCheck(val.ArtTransId);
                  if (transId != 0) {
                    frtr += '<td class="dt-head-center">'
                      + '<span><i class="bx bx-download stageDownload" style="font-size:18px; color: #556ee6; " title="Download" data-artId="'
                      + localStorage.aEID + '" data-proofId="35" data-activityId="140" data-transId="' + transId + '" data-trsno="' + trSNo + '"></i></span></td>';
                  }
                  else {
                    frtr += '<td></td>'
                    $("#chkFirstRelease").prop("checked", true);
                    $("#chkFirstRelease").attr("disabled", true);
                  }
                  frtr += '</tr>';
                }
                else {
                  $('#aEFCaption').html(val.Stage);
                  frth += '<tr>';
                  frth += '<th>#</th>';
                  frth += '<th>Stage</th>';
                  frth += '<th>Approved Date</th>';
                  frth += '<th>Uploaded Date</th>';
                  frth += '<th class="dt-head-center">Action</th>';
                  frth += '</tr>';
                  $('#TblFirstRelease thead').html(frth);

                  //tr data
                  trSNo = (e + 1);
                  frtr = '<tr>';
                  frtr += '<td>' + trSNo + '</td>';
                  frtr += '<td>' + val.Stage + '</td>';
                  frtr += '<td>' + GlobalConstants.FormatDate(val.RequestedDate) + '</td>';
                  frtr += '<td>' + GlobalConstants.FormatDate(val.UploadedDate) + '</td>';
                  let transId = GlobalConstants.isNaNCheck(val.ArtTransId);
                  if (GlobalConstants.FormatDate(val.RequestedDate) == '') {
                    frtr += '<td class="dt-head-center">'
                      + '<span><i class="bx bx-check FRApprove" style="font-size:18px;font-weight:bold; color: darkgreen; " title="Approve" data-artId="'
                      + localStorage.aEID + '" data-proofId="35" data-activityId="140" data-transId="' + transId + '" data-trsno="' + trSNo + '"></i></span></td>';
                  }
                  else {
                    frtr += '<td></td>'
                  }
                  frtr += '</tr>';
                }
                $('#TblFirstRelease tbody').append(frtr);
              });
            } catch (e) {
              console.log(e);
            }

            $('.FRApprove').click(function () {
              ngswal({
                title: "Approval Confirmation !",
                text: "Do you want to approve " + $('#aEFCaption').html() + " stage?",
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: false
              },
                function (isConfirm) {
                  if (isConfirm) {

                    ngswal({
                      title: 'Please wait processing!.....',
                      text: '',
                      showCancelButton: false,
                      showConfirmButton: false
                    });

                    localStorage.ApprovalType = 'FirstRelease';
                    $('#btnApprove').trigger("click");

                  } else {
                    ngswal("Cancelled", "You clicked cancel! :)", "warning");
                  }
                });
            });


            //Load Figure List
            try {

              $('#tbFigures tbody tr').remove();
              let figuresList = result.articleFigures;

              if (figuresList.length == 0) {
                $("#tabFigures").css("display", "none");
              }
              else {
                $("#tabFigures").css("display", "");
              }

              $.each(figuresList,
                function (e, val) {
                  let tr = "<tr>";
                  tr += '<td>' + (e + 1) + '</td>';
                  tr += '<td>' + GlobalConstants.isNullCheck(val.FigureName) + '</td>';
                  tr += '<td><center>' + GlobalConstants.isNullBoolean(val.OnlineColor) + '</center></td>';
                  tr += '<td><center>' + GlobalConstants.isNullBoolean(val.PrintColor) + '</center></td>';
                  tr += '<td><center>' + GlobalConstants.isNullBoolean(val.ChargeWaived) + '</center></td>';
                  tr += '<td><center>' + GlobalConstants.isNullBoolean(val.ChargeConfirmed) + '</center></td>';
                  tr += '</tr>';
                  $('#tbFigures tbody').append(tr);
                });

            } catch (e) {
            }

            //Load ArticleGraphicsProcess
            try {

              $('#tbGraphics tbody tr').remove();
              let graphicsList = result.articleGraphics;

              if (graphicsList.length == 0) {
                $("#tabGraphics").css("display", "none");
              }
              else {
                $('#tabGraphics a').html(graphicsList[0].TabTitle);
                $("#tabGraphics").css("display", "");
              }

              $.each(graphicsList, function (e, val) {
                $("#tabGraphics").css("display", "none");
                if (GlobalConstants.FormatDate(val.UploadDate) != '') {
                  let tr = "<tr>";
                  tr += '<td>' + (e + 1) + '</td>';
                  tr += '<td>' + GlobalConstants.FormatDate(val.UploadDate) + '</td>';

                  tr += '<td class="dt-head-center">'
                    + '<span><i class="bx bx-download gpDownload" style="font-size:18px;font-weight:bold; color: darkgreen;" title="Download"'
                    + ' data-transId="' + val.Id + '"></i></span></td>';
                  tr += '</tr>';
                  $('#tbGraphics tbody').append(tr);
                  $("#tabGraphics").css("display", "");
                }
              });

              $('.gpDownload').click(function () {
                let transId = $(this).attr('data-transId');
                ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadGpApi + '/' + transId);
              });

            } catch (e) {
            }

            //Load ArticleXpressParseErrorLog
            try {

              $('#tbXpressParseErrorLog tbody tr').remove();
              let xpressParseErrorLogList = result.xpressParseErrorLog;

              if (xpressParseErrorLogList.length == 0) {
                $("#tabXpressParseErrorLog").css("display", "none");
              }
              else {
                $("#tabXpressParseErrorLog").css("display", "");
              }

              $.each(xpressParseErrorLogList, function (e, val) {
                $("#tabXpressParseErrorLog").css("display", "none");

                let tr = "<tr>";
                tr += '<td>' + (e + 1) + '</td>';
                tr += '<td>' + GlobalConstants.FormatDate(val.PostedDate) + '</td>';
                tr += '<td>' + val.ReferenceNumber + '</td>';
                tr += '<td>' + val.InlineImageDocFile + '</td>';

                tr += '<td class="dt-head-center">'
                  + '<span><i class="bx bx-download parsererrorDownload" style="font-size:18px;font-weight:bold; color: darkgreen;" title="Download"'
                  + ' data-transId="' + val.Id + '"></i></span></td>';
                tr += '</tr>';
                $('#tbXpressParseErrorLog tbody').append(tr);
                $("#tabXpressParseErrorLog").css("display", "");

              });

              $('.parsererrorDownload').click(function () {
                let transId = $(this).attr('data-transId');
                ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadParserErrorApi + '/' + transId);
              });

            } catch (e) {
            }

            //Load Ingestion Package List
            try {

              $('#tbIngetsionPackageList tbody tr').remove();
              let _ingestPackageList = result.ingestPackageList;

              if (_ingestPackageList.length == 0) {
                $("#tabIngetsionPackageList").css("display", "none");
              }
              else {
                $("#tabIngetsionPackageList").css("display", "");
              }

              $.each(_ingestPackageList, function (e, val) {
                $("#tabIngetsionPackageList").css("display", "none");

                let tr = "<tr>";
                tr += '<td>' + (e + 1) + '</td>';
                tr += '<td>' + GlobalConstants.FormatDate(val.ReceivedDate) + '</td>';
                tr += '<td>' + val.TransmittalType + '</td>';
                tr += '<td>' + val.PackageName + '</td>';

                tr += '<td class="dt-head-center">'
                  + '<span><i class="bx bx-download ingestPacakgeDownload" style="font-size:18px;font-weight:bold; color: darkgreen;" title="Download"'
                  + ' data-transId="' + val.IngestID + '"></i></span></td>';
                tr += '</tr>';
                $('#tbIngetsionPackageList tbody').append(tr);
                $("#tabIngetsionPackageList").css("display", "");

              });

              $('.ingestPacakgeDownload').click(function () {
                let ingestId = $(this).attr('data-transId');
                ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadIngestionPackage + '/' + ingestId);
              });

            } catch (e) {
            }


            //Workflow details added
            $('#tblWorkflow tbody tr').remove();
            $('#divWorkflow').css('height', GlobalConstants.size.height - 180);
            let itemWorkflow = result.aWorkflowList;

            let itemCompleted = 0;
            let itagCss = 'font-size:18px;font-weight:bold;';
            let activityList = [];

            //Check Current and Previous Data NULL
            let Currentrow; let Prevrow;
            for (let i = 0; i < itemWorkflow.length; i++) {
              try {
                if (itemWorkflow[i].RevisedScheduleDate == '' || itemWorkflow[i].RevisedScheduleDate == null
                  || itemWorkflow[i].CompletedDate == '' || itemWorkflow[i].CompletedDate == null) {
                  Currentrow = i + 1;
                  Prevrow = i;
                  break;
                }
              } catch (e) {
                console.log(e);
              }
            }
            //Enable Update option to last Activity
            if (Currentrow == null || Currentrow == '') {
              Currentrow = itemWorkflow.length;
              Prevrow = Currentrow - 1;
            }

            $.each(itemWorkflow, function (e, val) {

              //Check Reference Upload Activity
              if (val.ReferenceUpload) {
                refUpload = val.ReferenceUpload;
              }
              activityList.push(val.ActivityID);

              let roundCount = activityList.filter(eActId => eActId === val.ActivityID).length;
              let roundstring = ' R' + roundCount;
              if (roundCount == 1) {
                roundstring = '';
              }
              //First Proof File from vendor(2)
              if ((val.ActivityID === '2') && (val.CompletedDate != null)) {
                onDemandFromVendor = true;
              }
              else if ((val.ActivityID === '2') && (val.CompletedDate == null)) {
                onDemandFromVendor = false;
              }

              let trcolor = 'style="background-color:' + (val.CompletedDate == null && itemCompleted == 1 ? 'lightblue' : 'white') + ';"';

              let firstIncomplete = val.CompletedDate == null && itemCompleted == 1 ? true : false;
              if (val.CompletedDate != null) {
                itemCompleted = 1;
              }
              else {
                itemCompleted = 0;
              }

              //ProjectPlan SNo Allocate
              trSNo = (e + 1);
              let tr = '<tr ' + trcolor + ' data-rowno="' + trSNo + '">';
              tr += '<td>' + trSNo + '</td>';

              if (val.ReopenDetails != "") {
                tr += '<td>' + val.Activity + roundstring + ' (' + val.ReopenDetails + ')' + '</td>';
              }
              else {

                tr += '<td>' + val.Activity + roundstring + '</td>';
              }

              // ScheduleDate Column only for Metadatashow based
              if (_scheduleColumn) {
                tr += '<td>' + GlobalConstants.FormatDate(val.ScheduleDate) + '</td>';
              }

              // RevisedScheduleDate Column only for Metadatashow based
              if (_revisedScheduleColumn) {
                tr += '<td>' + GlobalConstants.FormatDate(val.RevisedScheduleDate) + '</td>';
              }

              if ((val.EGOption == "FPPGPending" || val.EGOption == "ManualPGPending"
                || val.EGOption == "PCCorrectionPending" || val.EGOption == "FPQCPending"
                || val.EGOption == "FinalPGPending" || val.EGOption == "PCPending"
                || val.EGOption == "AutoFailPGPending"
                || val.EGOption == "LinkVerificationPending") && val.CompletedDate == null

              ) {
                tr += '<td><span title="Allocated to user : ' + val.AllocateUserName + '">' + val.AllocateUserName + '</span></td>';
              }
              else {
                tr += '<td>' + GlobalConstants.FormatDate(val.CompletedDate) + '</td>';
              }

              //CorrectionType Xml or Pdf Option
              if (val.ActivityID.toString() == '16') {
                if (val.CorrectionTypeXmlPdf == true) {
                  $('#divCorrTypeXmlPdf').show();
                }
                else {
                  $('#divCorrTypeXmlPdf').hide();
                }
              }

              let customAttr = 'data-artId="' + id +
                '" data-planflowId="' + val.ID +
                '" data-proofId="' + val.ProofingID +
                '" data-transId="' + val.ArtTransID +
                '" data-activityId="' + val.ActivityID.toString() +
                '" data-activity="' + val.Activity +
                '" data-downloadaction="' + val.DownloadAction.toString() +
                '" data-checkvoliss="' + val.CheckVolIssue.toString() +
                '" data-jrlnotes="' + val.ApproveActionJrlNotes.toString() +
                '" data-approveattach="' + val.ApproveAttachment.toString() +
                '" data-DelayReason="' + val.DelayReason.toString() +
                '" data-CIDGen="' + val.CidDoiValidation.toString() +
                '" data-epubvalid="' + val.EPubDateValidation.toString() +
                '" data-correctioninputfile="' + val.CorrectionInputFile.toString() +
                '" data-correctiontnputinstructions="' + val.CorrectionInputInstructions.toString() +
                '" data-trsno="' + trSNo + '"';

              var workflowaction = '';

              if (val.ManuscriptFileView == true) {
                workflowaction += `<i class="fa fa-eye manuscriptfileview"
                                  style="font-size:18px;color:#556ee6;cursor:pointer;padding-right:5px"
                                  title="Manuscript File View"></i>`;
              }

              if (val.CompletedDate == null && firstIncomplete && val.InComplete) {
                workflowaction += '<span><i class="fa fa-ban incomplete" style="' + itagCss + ' color:Red; " title="Incomplete" ' + customAttr + '></i></span>&nbsp;'
              }

              if (val.EGOption == "LinkVerification" && firstIncomplete && val.CompletedDate == null) {
                workflowaction += '<span><i class="bx bx-user-check LinkVerification" style="' + itagCss + ' color:#556ee6; " title="Allocate" ' + customAttr + '></i></span>&nbsp;';
              }

              if ((val.EGOption == "LinkVerificationPending") && (val.AllocateUserID == localStorage.aLoginID) && val.CompletedDate == null) {
                workflowaction += '<span><i class="bx bx-user-check LinkVerifyPendingReallocate" style="' + itagCss + ' color:darkyellow ; " title="Re-allocate Link Verification" data-artId="' + customAttr + '></i></span>&nbsp;';
              }

              if ((val.EGOption == "LinkVerificationPending") && (val.AllocateUserID != localStorage.aLoginID) && val.CompletedDate == null) {
                workflowaction += '<span><i class="bx bx-user-check LinkVerifyPendingReallocate" style="' + itagCss + ' color:darkyellow ; " title="Re-allocate Link Verification" data-artId="' + customAttr + '"></i></span>&nbsp;';
              }

              if ((val.CompletedDate != null && val.DownloadActionAfterComplete == true) || (firstIncomplete == true && val.DownloadAction == true)) {
                workflowaction += '<span><i class="bx bx-download filedownload" style="' + itagCss + ' color:#556ee6; " title="Download" ' + customAttr + '></i></span>&nbsp;';
              }


              //Express Workflow Link
              if (val.EGOption == "LinkVerification" || val.EGOption == "LinkVerificationPending" || val.CompletedDate != null) {


                if (val.ArticleLinkiCodex != "" && val.AllocateUserID != 0) {
                  workflowaction += '<i class="bx bx-link egLink express" style="' + itagCss + ' color:orange; " title="' + val.Activity + '- ArticleLink" data-mode="Xpress" data-EGLink="' + val.ArticleLinkiCodex + '"></i>';
                }

                if (val.EditorLinkiCodex != "" && val.AllocateUserID != 0) {
                  workflowaction += '<i class="bx bx-link egLink express" style="' + itagCss + ' color:#556ee6; " title="' + val.Activity + ' - EditorLink" data-mode="Xpress" data-EGLink="' + val.EditorLinkiCodex + '"></i>';
                }

                if (val.PAGLinkiCodex != "" && val.AllocateUserID != 0) {
                  workflowaction += '<i class="bx bx-link egLink express" style="' + itagCss + ' color:#e6556e; " title="' + val.Activity + ' - PGLink" data-mode="Xpress" data-EGLink="' + val.PAGLinkiCodex + '"></i>';
                }
                //xPress Workflow Link available status check

                //Express Stage check for WIP
                if (val.ActivityID == 173 || val.ActivityID == 161 || val.ActivityID == 162
                  || val.ActivityID == 163 || val.ActivityID == 164 || val.ActivityID == 165 || val.ActivityID == 166) {
                  if (val.ArticleLinkiCodex == "" && val.EditorLinkiCodex == "" && val.PAGLinkiCodex == "") {
                    workflowaction = '';
                    if ((val.CompletedDate != null && val.DownloadActionAfterComplete == true) || (firstIncomplete == true && val.DownloadAction == true)) {
                      workflowaction += '<span><i class="bx bx-download filedownload" style="' + itagCss + ' color:#556ee6; " title="Download" ' + customAttr + '></i></span>&nbsp;';
                    }
                    else {
                      workflowaction = '<i class="fa fa-spinner fa-spin" style="font-size:16px;"></i> ';
                    }
                  }

                }
              }

              //Check EG SnapshotLink availability
              if (val.SnapshotLink != "") {
                //Chech EG Attachment Link availability
                let _splitLink = val.SnapshotLink.split('_Split_');
                workflowaction += '<i class="bx bx-download egLink" style="' + itagCss
                  + ' color:darkgreen; " title="Snapshot" data-EGLink="' + _splitLink[0] + '"></i>';

                if (_splitLink.length == 2) {
                  if (GlobalConstants.isNullCheck(_splitLink[1]) != '') {
                    workflowaction += '&nbsp;<i class="bx bx-paperclip egLink" style="' + itagCss
                      + ' color:darkgreen; " title="Attchments" data-EGLink="' + _splitLink[1] + '"></i>';
                  }
                }
              }

              //Check Approve Rights Validation for Final Approve ,Correction and One more review
              if (approveArticleRights == "Yes") {

                if (val.ExpressCorrection == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-edit ExpressCorrection" style="' + itagCss + ' color:red; " title="Express Correction" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.ExpressCorrectionUpload == true && val.CompletedDate == null) {
                  workflowaction += '<span><i class="bx bx-upload ExpressCorrectionUpload" style="' + itagCss + ' color:orange; " title="Correction Upload" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.ExpressCorrectionUpload == true && val.CompletedDate != null) {
                  workflowaction += '<span><i class="bx bx-download ECUploaded" style="' + itagCss + ' color:green; " title="Download : Uploaded File" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.iCodexFlexyPageEditorLink == true && val.CompletedDate == null
                  && (val.ArticleLinkiCodex == "" || val.ReopenDetails?.trim() == "Uploaded")) {
                  workflowaction += `<span><i class="bx bx-link-external iCodexFlexyPageEditorLink"
                  style="${itagCss};color:orange;" title="Flexy Page EditorLink" ${customAttr}></i></span>&nbsp;`;
                }

                if (val.iCodexFlexyPageEditorLink == true && val.CompletedDate == null
                  && val.ArticleLinkiCodex?.trim() != "" && val.ReopenDetails?.trim() == "") {
                  workflowaction += `<span><i class="bx bx-upload iCodexFlexyPageUpload"
                          style='${itagCss} color:red;' title="Correction Upload" ${customAttr}></i></span>&nbsp;`;
                }

                if (val.iCodexFlexyPageEditorLink == true) {
                  if (val.ArticleLinkiCodex != "" && val.ArticleLinkiCodex != null && val.ReopenDetails?.trim() != "Uploaded") {
                    workflowaction += `<i class="bx bx-link egLink express" style="${itagCss};color:#556ee6;
                                     title='${val.Activity}' data-mode='Xpress' data-EGLink='${val.ArticleLinkiCodex}'></i>`;
                  }
                }

                if (val.CheckPublishAction == true && val.CompletedDate == null && firstIncomplete == true && val.FeaturesPhysics != '') {
                  workflowaction += '<span><i class="bx bx-list-check publishCheck" style="' + itagCss + ' color:darkblue;" title="Publish Status Check" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.CorrectionAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-edit fileCorrection" style="' + itagCss + ' color:red; " title="Correction" ' + customAttr + '></i></span>&nbsp;';
                }
                if (val.UploadAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-check QCApprove" style="' + itagCss + ' color:#556ee6;" title="QC Approve" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.ApproveForRevised == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-check revisedfileApprove" style="' + itagCss + ' color:darkgreen;" title="Revised Approve" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.ProofingAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-check proofApprove" style="' + itagCss + ' color:darkgreen;" title="Proofing" ' + customAttr + '></i></span>&nbsp;';
                }
                if (val.ProofingApproveAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-check ProofingEPTApprove" style="' + itagCss + ' color:darkgreen;" title="Proofing Approve" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.ProofingCorrectionAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-edit ProofingEPTCorrection" style="' + itagCss + ' color:red; " title="Correction" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.ProofingOneMoreReviewAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-repeat ProofingEPTOneMoreReview" style="' + itagCss + ' color:#556ee6; " title="Correction with OneMoreReview" ' + customAttr + '></i></span>&nbsp;';
                }

                //Check iCodex link empty based approve action
                if (val.ArticleLinkiCodex != "" && val.ArticleLinkiCodex != null) {
                  if (val.ReopenDetails == 'Uploaded') {
                    if (val.ApproveAction == true && val.CompletedDate == null && firstIncomplete == true) {
                      workflowaction += '<span><i class="bx bx-check fileApprove" style="' + itagCss + ' color:darkgreen;" title="Approve" ' + customAttr + '></i></span>&nbsp;';
                    }
                  }
                }
                else {
                  if (val.ApproveAction == true && val.CompletedDate == null && firstIncomplete == true) {
                    workflowaction += '<span><i class="bx bx-check fileApprove" style="' + itagCss + ' color:darkgreen;" title="Approve" ' + customAttr + '></i></span>&nbsp;';
                  }
                }

                if (val.OneMoreReviewAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-repeat articleReview" style="' + itagCss + ' color:darkblue;" title="One more review" ' + customAttr + '></i></span>&nbsp;';
                }
                if (val.OneMoreReviewSignalAction == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-repeat articleReviewSignal" style="' + itagCss + ' color:darkblue;" title="One more review" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.ActivityDateModify == true && val.CompletedDate == null && firstIncomplete == true) {
                  workflowaction += '<span><i class="bx bx-edit activityDateModify" style="' + itagCss + ' color:darkblue;" title="Update Completed Date" ' + customAttr + '></i></span>&nbsp;';
                }

                if (val.EGOption == "EGSent" && val.EGAction == true) {
                  if (val.EGLink != "") {
                    workflowaction += '<i  class="bx bx-link egLink" style="' + itagCss + ' color:darkgreen; " title="EG" data-EGLink="' + val.EGLink + '"></i>';
                  }
                  if (val.EPTLink != "") {
                    workflowaction += '<i  class="fas fa-paper-plane eptLink" style="' + itagCss + ' color:#556ee6; " title="EPT" data-EPTLink="' + val.EPTLink + '"></i>';
                  }
                }
                else if (val.EGLink != "" && val.CompletedDate != null) {
                  workflowaction += '<i  class="bx bx-link egLink" style="' + itagCss + ' color:darkgreen; " title="EG" data-EGLink="' + val.EGLink + '"></i>';
                }

                //if (val.AllocateAction == true && val.AllocateUserID == 0 && val.CompletedDate == null) {
                //  workflowaction = '<span><i class="bx bx-user-check ManualFR" style="' + itagCss + ' color:#556ee6; " title="Allocate for manual pagination" ' + customAttr + '></i></span>&nbsp;';
                //}

              }

              //Reference Upload Popup configuration
              if (refUpload) {
                let refFile = '';
                if (val.ReferenceFile != null) {
                  refFile = val.ReferenceFile;
                }
                workflowaction += '<span><i class="bx bx-upload ReferenceNote" style="' + itagCss + ' color:orange;font-weight:bold" title="Reference Data"'
                  + ' data-activityId="' + val.ActivityID.toString() + '"'
                  + ' data-activity="' + val.Activity.toString() + '"></i></span>&nbsp;';
              }

              //Graphics and Xml Correction Upload 

              if (workflowaction == '') {
                workflowaction = '';
              }

              tr += '<td class="dt-head-center">' + workflowaction + '</td>';
              tr += '</tr>';
              $('#tblWorkflow tbody').append(tr);

            });

            $('.ReferenceNote').click(function () {
              $('#TxtInstructionRN').val('');
              $('#FU_AttchmentRN').val('');
              localStorage.ActivityId = $(this).attr('data-activityId');
              $('#hRefNoteTitle').html('Reference Note - ' + $(this).attr('data-activity'));
              ArticleinfoComponent.PopulateReferenceNote(localStorage.aEID, localStorage.ActivityId);
            });

            //View Live Staging Weblink
            $('.AtypeonStage').click(function () {
              let articleDOI = ArticleinfoComponent.jrnlCode + '.' + ArticleinfoComponent.articleNo;
              window.open(
                ArticleinfoComponent.awebLink + '/' + articleDOI, "_blank");
            });

            //Workflow stage package download
            $('.publishCheck').click(function () {

              var aItemL = {
                LoginId: localStorage.aLoginID,
                ArticleId: localStorage.aEID
              }
              ApiMethod.postMethod(ArticleinfoComponent.modelItem.checkArticlePublishApi, aItemL).subscribe(
                response => {
                  if (response.status == "Failed") {
                    ngswal({
                      position: "top-end",
                      type: "error",
                      title: "Error!",
                      text: response.message
                    });
                  }
                  else {
                    ngswal({
                      position: "top-end",
                      type: "success",
                      title: "Check Publish Status !",
                      text: response.message
                    });
                  }

                  ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId, false, false);
                },
                error => {
                  ngswal("Failed!", error.error.Message, "warning");
                  $("#LoadingImagePopup").hide();
                }
              );
            });

            $('.incomplete').click(function () {
              //ArticleinfoComponent.ShowHoldReleasePopUp(ArticleinfoComponent.articleNo);
            });

            $('.stageDownload,.FPQCPending,.ManualPGPending,.AtypeonPending,.FPPGPending,.ManualFRPending,.PCPending,.PCPGPending,.filedownload').click(function () {
              let artId = $(this).attr('data-artId');
              let proofId = $(this).attr('data-proofId');
              let transId = $(this).attr('data-transId');
              let fileSno = $(this).attr('data-trsno');
              let activityId = $(this).attr('data-activityId');
              ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadWfApi
                + '/' + artId + '/' + proofId + '/' + localStorage.aLoginID + '/' + transId + '/' + fileSno + '/' + activityId);
            });

            $('.ECUploaded').click(function () {
              let artId = $(this).attr('data-artId');
              let proofId = $(this).attr('data-proofId');
              let transId = $(this).attr('data-transId');
              let fileSno = $(this).attr('data-trsno');
              let activityId = $(this).attr('data-activityId');
              ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadECUApi
                + '/' + artId + '/' + proofId + '/' + localStorage.aLoginID + '/' + transId + '/' + fileSno + '/' + activityId);
            });

            $('.FPQCPendingReallocate,.ManualPGPendingReallocate,.AtypeonPendingReallocate,.FPPGPendingReallocate,.ManualFRPendingReallocate,.PCPendingReallocate,.PCPGPendingReallocate,.LinkVerifyPendingReallocate').click(function () {
              let artId = $(this).attr('data-artId');
              let proofId = $(this).attr('data-proofId');
              let activityId = $(this).attr('data-activityId');
              let fileSno = $(this).attr('data-trsno');
              ArticleinfoComponent.aartId = artId;
              ArticleinfoComponent.aproofId = proofId;
              ArticleinfoComponent.aactivityId = activityId;
              ArticleinfoComponent.afileSno = fileSno;
              let transStatus = $(this).attr('data-transStatus');
              if (transStatus == "Inprocess") {
                ngswal({
                  title: "Article has been allocated to a user. Do you wish to revoke from them and re-allocate?",
                  text: "Article Re-allocate Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: true,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {
                      $('#btnReallocate').trigger("click");

                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }
              else {
                $('#btnReallocate').trigger("click");
              }

            });

            $('.ManualPG,.FPQC,.Atypeon,.FPPG,.ManualFR,.PCReady,.PCPG,.LinkVerification').click(function () {
              let artId = $(this).attr('data-artId');
              let proofId = $(this).attr('data-proofId');
              let activityId = $(this).attr('data-activityId');
              let fileSno = $(this).attr('data-trsno');
              ArticleinfoComponent.GetAllocateOption(artId, proofId, activityId, fileSno);
            });

            $('#TxtPopVolume,#TxtPopIssue').change(function () {
              $("#LoadingImageMeta").show();
              var aArticleItemL = {
                ArticleId: localStorage.aEID,
                Volume: $("#TxtPopVolume").val(),
                Issue: $("#TxtPopIssue").val()
              }

              ApiMethod.postMethod(ArticleinfoComponent.modelItem.checkVolumeIssueApi, aArticleItemL).subscribe(
                response => {
                  if (response.status == "Failed") {
                    if (response.message.indexOf('volume') > 0) {
                      $("#TxtPopVolume").val('');
                    }
                    else if (response.message.indexOf('issue') > 0) {
                      $("#TxtPopIssue").val('');
                    }

                    ngswal("Failed !", response.message, "error");
                  }
                  $("#LoadingImageMeta").hide();
                },
                error => {
                  ngswal("Failed !", error.error.Message, "warning");
                  $("#LoadingImageMeta").hide();
                }
              );
            });

            $('.egApprove').click(function () {
              ngswal({
                title: "Do you want to send the Proofing to the author?",
                text: "Article EG Confirmation !",
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: false
              },
                function (isConfirm) {
                  if (isConfirm) {

                    ngswal({
                      title: 'Please wait processing!.....',
                      text: '',
                      showCancelButton: false,
                      showConfirmButton: false
                    });


                    $('#btnEGApprove').trigger("click");

                  } else {
                    ngswal("Cancelled", "You clicked cancel! :)", "warning");
                  }
                });
            });

            $('.eptApprove').click(function () {
              ngswal({
                title: "Do you want to send the PDF to the author?",
                text: "Article EPT Confirmation !",
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: false
              },
                function (isConfirm) {
                  if (isConfirm) {

                    ngswal({
                      title: 'Please wait processing!.....',
                      text: '',
                      showCancelButton: false,
                      showConfirmButton: false
                    });

                    $('#btnEPTApprove').trigger("click");

                  } else {
                    ngswal("Cancelled", "You clicked cancel! :)", "warning");
                  }
                });
            });

            $('.egSent').click(function () {
              let egApp = $(this).attr('data-EGApp');
              let eptApp = $(this).attr('data-EPTApp');
              if (egApp > 0) {
                ngswal("Info!", "EG link already sent.", "info");
              }
              else if (eptApp > 0) {
                ngswal("Info!", "EPT link already sent. So you can't send EG.", "info");
              }
              else {
                ngswal({
                  title: "Do you want to send the PDF to the author?",
                  text: "Article EG Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {

                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });


                      $('#btnEGApprove').trigger("click");

                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }
            });

            $('.eptSent').click(function () {
              let eptApp = $(this).attr('data-EPTApp');
              if (eptApp > 0) {
                ngswal("Info!", "EPT link already sent.", "info");
              }
              else {
                ngswal({
                  title: "Do you want to send the PDF to the author?",
                  text: "Article EPT Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {

                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });

                      $('#btnEPTApprove').trigger("click");

                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }
            });

            $('.egLink').click(function () {
              let egLink = $(this).attr('data-EGLink');

              window.open(
                egLink, "_blank");
            });

            $('.eptLink').click(function () {
              let eptLink = $(this).attr('data-EPTLink');
              window.open(
                eptLink, "_blank");
            });

            $('.articleApprove').click(function () {
              let transId = $(this).attr('data-transId');
              if ((transId == null || transId == 0) && ArticleinfoComponent.noNeedPDF == false) {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
                $('#LoadingImage').hide();
              }
              else if ($('#TxtPopVolume').val() == '' || $('#TxtPopVolume').val() == '0') {
                ngswal("Warning !", "Enter Volume!", "warning");
                $('#LoadingImage').hide();
              }
              else if ($('#TxtPopIssue').val() == '' || $('#TxtPopIssue').val() == '0') {
                ngswal("Warning !", "Enter Issue!", "warning");
                $('#LoadingImage').hide();
              }
              else {
                ngswal({
                  title: "Do you want to approve the article for publication on Atypon staging?",
                  text: "Article Approve Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {

                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });


                      $('#btnApprove').trigger("click");
                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }
            });

            $('.iCodexFlexyPageEditorLink').click(function () {
              $("#LoadingImage").show();
              ApiMethod.getMethod(`api/flexypageeditorlink/${localStorage.aEID}`).subscribe(
                resonse => {
                  $("#LoadingImage").hide();

                  if (resonse.status == false) {
                    ngswal("Warning", resonse.message, "warning");
                  }
                  else {
                    ngswal("Success", resonse.message, "info");
                  }

                },
                error => {
                  $("#LoadingImage").hide();
                }
              );
            });

            $('.ExpressCorrection').click(function () {
              $('#TxtECInstruction').val('');
              $('#FU_ECAttchment').val('');
              $('#ddlExpressCorrectionType').val('Graphics').change();

              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              let downloadAction = $(this).attr('data-downloadaction');
              customfunctions.SetTodayDateValues("#Txt_DueDate");
              if ((transId == null || transId == 0) && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to book a correction !", "warning");
              }
              else {
                $('#myModal_ExpressCorrections').show();
              }
            });

            $('.ExpressCorrectionUpload').click(function () {
              $('#ecuTitle').html($(this).attr('data-activity') + ' Upload');
              $('#FU_ECUAttchment').val('');
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              localStorage.activity = $(this).attr('data-activity');
              $('#myModal_ExpressCorrectionUpload').show();
            });

            $('.iCodexFlexyPageUpload').click(function () {
              $("#FU_iCodexFlexyPageUpload").click();
            });




            $('.manuscriptfileview').click(function () {
              $('#divManuFileList').html("");

              $("#LoadingImagePopupMF").show();
              ApiMethod.getMethod(`api/manuscriptfilelist/${localStorage.aEID}`).subscribe(
                resonse => {
                  let _fileList = resonse.fileList;

                  let htmlData = '<table class="dataTable table" width="100%" cellpadding="5" cellspacing="5" border="1">';

                  htmlData += `<tr> <th>#</th><th>Date</th><th>Article No</th><th>File</th> </tr>`;

                  $.each(_fileList, function (i, val) {
                    htmlData += `
                      <tr>
                          <td>${val.Id}</td>
                          <td>${GlobalConstants.FormatDate(val.ReceivedDate)}</td>
                          <td>${val.ArticleNo}</td>
                          <td>
                          <span data-id='${val.Id}'
                            class='manuscriptfiledownload'
                            style='cursor:pointer !important;color:#556ee6;text-decoration:underline;width:auto !important;'>
                            ${val.ManuscriptFile}
                          </span>
                          </td>
                      </tr>`;
                  });

                  htmlData += '</table>';
                  $('#divManuFileList').html(htmlData);

                  $('.manuscriptfiledownload').click(function () {
                    let _id = $(this).attr('data-id');
                    ApiMethod.Downloadfile(`api/manuscriptfiledownload/${_id}`);
                  });


                },
                error => {
                  $("#LoadingImagePopupMF").hide();
                }
              );


              $('#myModal_ManuscriptFile').show();
            });

            $('.articleCorrection,.fileCorrection').click(function () {
              $('#TxtInstruction').val('');
              $('#FU_Attchment').val('');
              $('#Txt_DueDate').val();
              $('#ddlCorrTypeXmlPdf').val('Select').change();
              $('#divCorrTypeEpubDate').hide();
              $('div[name="correctionPopup"] input').val('');
              customfunctions.SetTodayDateValues("#Txt_DueDate", 1);
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              let downloadAction = $(this).attr('data-downloadaction');

              if ((transId == null || transId == 0) && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to book a correction !", "warning");
              }
              else {
                $('.CorrectionInputFile').show(); $('.CorrectionInputInstructions').show();
                if ($(this).attr('data-correctioninputfile').toString() == "false") {
                  $('.CorrectionInputFile').hide();
                }
                if ($(this).attr('data-correctiontnputinstructions').toString() == "false") {
                  $('.CorrectionInputInstructions').hide();
                }

                $('#myModal_Corrections').show();
              }

            });

            $('.fileQCApprove').click(function () {
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              let downloadAction = $(this).attr('data-downloadaction');
              if ((transId == null || transId == 0) && ArticleinfoComponent.noNeedPDF == false && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
                $('#LoadingImage').hide();
              }
              else {
                ngswal({
                  title: "Do you want to approve the article for next stage?",
                  text: "Article Approve Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {

                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });


                      $('#btnRevisedFileApprove').trigger("click");
                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }
            });

            $('.revisedfileApprove').click(function () {
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              let downloadAction = $(this).attr('data-downloadaction');
              if ((transId == null || transId == 0) && ArticleinfoComponent.noNeedPDF == false && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
                $('#LoadingImage').hide();
              }
              else {
                ngswal({
                  title: "Do you want to approve the article for next stage?",
                  text: "Article Revised Approve Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {

                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });


                      $('#btnRevisedFileApprove').trigger("click");
                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }
            });

            $('.proofApprove').click(function () {
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              var confirmTxt = "";
              if (localStorage.ActivityId == 66) {
                confirmTxt = "Article Proof Approve Confirmation !";
              }
              else {
                confirmTxt = "Article Outsourcing Approve Confirmation !";
              }
              ngswal({
                title: "Do you want to approve the article for next stage?",
                text: confirmTxt,
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: false
              },
                function (isConfirm) {
                  if (isConfirm) {

                    ngswal({
                      title: 'Please wait processing!.....',
                      text: '',
                      showCancelButton: false,
                      showConfirmButton: false
                    });


                    $('#btnProofingFileApprove').trigger("click");
                  } else {
                    ngswal("Cancelled", "You clicked cancel! :)", "warning");
                  }
                });

            });

            $('.ProofingEPTApprove').click(function () {
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              let downloadAction = $(this).attr('data-downloadaction');
              if ((transId == null || transId == 0) && ArticleinfoComponent.noNeedPDF == false && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
                $('#LoadingImage').hide();
              }
              else {
                ngswal({
                  title: "Do you want to approve the article?",
                  text: "Article Approve Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {
                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });
                      $('#btnProofingEPTApprove').trigger("click");
                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }
            });

            $('.ProofingEPTCorrection').click(function () {

              let transId = $(this).attr('data-transId');
              let downloadAction = $(this).attr('data-downloadaction');
              localStorage.ActivityId = $(this).attr('data-activityId');
              $('div[name="correctionEptPopup"] input').val('');
              if ((transId == null || transId == 0) && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to book a correction !", "warning");
              }
              else {
                $('.CorrectionInputFile').show(); $('.CorrectionInputInstructions').show();
                if ($(this).attr('data-correctioninputfile').toString() == "false") {
                  $('.CorrectionInputFile').hide();
                }
                if ($(this).attr('data-correctiontnputinstructions').toString() == "false") {

                  $('.CorrectionInputInstructions').hide();
                }

                $('#myModal_EPTCorrections').show();
              }

            });

            $('.fileApprove').click(function () {
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              let downloadAction = $(this).attr('data-downloadaction');
              let checkvolissAction = $(this).attr('data-checkvoliss');
              let checkjrlNotes = $(this).attr('data-jrlnotes');
              let approveattach = $(this).attr('data-approveattach');
              let checkDelay = $(this).attr('data-DelayReason');
              let checkCIDGen = $(this).attr('data-CIDGen');
              let epubvalid = $(this).attr('data-epubvalid');

              $('#TxtDelayReason').val('');
              $('#TxtCID').val(''); $('#TxtPopEpubDate').val($('#txtEPublDt').val());
              if ((transId == null || transId == 0) && ArticleinfoComponent.noNeedPDF == false && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
                $('#LoadingImage').hide();
              }
              else {
                if (checkjrlNotes == 'true') {
                  var aItemL = {
                    LoginId: localStorage.aLoginID,
                    ArticleId: localStorage.aEID
                  }
                  ApiMethod.postMethod(ArticleinfoComponent.modelItem.journalNotesApi, aItemL).subscribe(
                    resonse => {
                      let itemL = resonse.resultData;
                      $('#jrlNotesTitle').html(itemL[0].PopupCaption);

                      let notesList = "<h5>Journal Notes</h5>";
                      notesList += '<div>' + GlobalConstants.isNullCheck(itemL[0].JournalNotes) + '</div>';
                      notesList += "<h5> Common Notes</h5>";
                      notesList += '<div>' + GlobalConstants.isNullCheck(itemL[0].GeneralNotes) + '</div>';

                      $('#divJrlNotesData').html(notesList);

                      $('#myModal_JrlNotes').show();
                    },
                    error => {
                      ngswal("Failed!", error.error.Message, "warning");
                      $("#LoadingImagePopup").hide();
                    }
                  );
                }
                else if (checkvolissAction == 'true') {
                  if ($('#TxtPopVolume').val() == '' || $('#TxtPopVolume').val() == '0') {
                    ngswal("Warning !", "Enter Volume!", "warning");
                    $('#LoadingImage').hide();
                  }
                  else if ($('#TxtPopIssue').val() == '' || $('#TxtPopIssue').val() == '0') {
                    ngswal("Warning !", "Enter Issue!", "warning");
                    $('#LoadingImage').hide();
                  }
                  else if (checkDelay == 'true') {
                    $('#myModal_Delay').show();
                  }
                  else if (checkCIDGen == 'true') {
                    ArticleinfoComponent.getUpdatedCID();
                  }
                  else if (epubvalid == 'true') {
                    $('#myModal_PubDate').show();
                  }
                  else {
                    ArticleinfoComponent.ArticleApproval();
                  }
                }
                else if (checkDelay == 'true') {
                  $('#myModal_Delay').show();
                }
                else if (checkCIDGen == 'true') {
                  $('.PublishDateApp').css("display", "");
                  customfunctions.SetTodayDateValues("#Txt_PublDate");
                  ArticleinfoComponent.getUpdatedCID();
                }
                else if (epubvalid == 'true') {
                  $('#myModal_PubDate').show();
                }
                else if (approveattach == 'true') {
                  $('#myModal_ApproveAttach').show();
                }
                else {
                  ArticleinfoComponent.ArticleApproval();
                }
              }
            });

            $('.articleReview').click(function () {
              let transId = $(this).attr('data-transId');
              let downloadAction = $(this).attr('data-downloadaction');
              localStorage.ActivityId = $(this).attr('data-activityId');
              if ((transId == null || transId == 0) && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to send review !", "warning");
              }
              else {
                $('#ddlMailTo').val(-1).change();
                $('#myModal_Review').show();
              }

            });

            $('.articleReviewSignal').click(function () {
              let transId = $(this).attr('data-transId');
              localStorage.ActivityId = $(this).attr('data-activityId');
              let downloadAction = $(this).attr('data-downloadaction');
              if ((transId == null || transId == 0) && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to send review !", "warning");
              }
              else {
                $('#btnProofingConfigReview').trigger("click");
              }
            });

            $('.activityDateModify').click(function () {
              let planflowId = $(this).attr('data-planflowId');
              let trsno = $(this).attr('data-trsno');
              localStorage.planflowId = planflowId;
              if ((planflowId == null || planflowId == 0)) {
                ngswal("Warning", "Invalid Activity PlanFlowId!", "warning");
              }
              else {
                $('#StageDateChangeTitle').html("Change for " + $("#tblWorkflow tr[data-rowno='" + trsno + "'] td:eq(1)")[0].innerHTML);
                $('#myModal_StageDateChange').show();
              }
            });

            $('.QCCorrection').click(function () {
              let proofId = $(this).attr('data-proofId');
              let transId = $(this).attr('data-transId');
              let downloadAction = $(this).attr('data-downloadaction');
              if ((transId == null || transId == 0) && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to book a correction !", "warning");
              }
              else {
                $('div[name="correctionPopup"] input').val('');
                customfunctions.SetTodayDateValues("#Txt_DueDate");
                $('#myModal_QCCorrections').show();
              }

            });

            $('.AtypeonUpload').click(function () {
              $('div[name="correctionPopup"] input').val('');
              customfunctions.SetTodayDateValues("#Txt_DueDate");
              let transId = $(this).attr('data-transId');
              if (transId == null || transId == 0) {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
              }
              else {
                $('#myModal_AtypeonCorrections').show();
              }

            });

            $('.AtypeonLog').click(function () {
              var aItemL = {
                LoginId: localStorage.aLoginID,
                ArticleId: localStorage.aEID
              }
              ApiMethod.postMethod(ArticleinfoComponent.modelItem.atyponLogApi, aItemL).subscribe(
                resonse => {
                  let itemL = resonse.aAtypeonError;
                  $('#tblAtypeonHistory tbody tr').remove();
                  //$.each(itemL,
                  //  function (e, val) {
                  let tr = "<tr>";
                  tr += '<td>' + GlobalConstants.isNullCheck(itemL[0].ConversionLog) + '</td>';
                  tr += '</tr>';
                  $('#tblAtypeonHistory tbody').append(tr);

                  //});
                  $('.titleAH').text("Conversion Log");

                  $('#myModal_AtypeonHistory').show();
                },
                error => {
                  ngswal("Failed!", error.error.Message, "warning");
                  $("#LoadingImagePopup").hide();
                }
              );
            });

            $('.QCApprove').click(function () {
              let proofId = $(this).attr('data-proofId');
              let transId = $(this).attr('data-transId');
              let downloadAction = $(this).attr('data-downloadaction');
              localStorage.ActivityId = $(this).attr('data-activityId');
              if ((transId == null || transId == 0) && downloadAction == 'true') {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
              }
              else {
                ngswal({
                  title: "Do you want to approve the article? ",
                  text: "Article Approve Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {
                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });
                      $('#btnQCApprove').trigger("click");
                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }

            });

            $('.showNotesPopUp').click(function () {
              //$('#TxtGeneralNote').jqte();
              $('.titleNotes').text('Notes');
              //$('#TxtGeneralNote').val(GlobalConstants.isNullCheck(itemL[0].Notes));
              $('#TxtGeneralNote').val($('#spNotes').html());
              $('#myModal_GeneralNotes .jqte_editor').html(GlobalConstants.isNullCheck(itemL[0].Notes));
              $('#myModal_GeneralNotes').show();
            });

            //Check Xpress Log details
            if ($(xpressLog).length > 0) {
              $('.imgXpressLogo').show();
              $('#tblLog thead tr').remove();
              $('#tblLog tbody tr').remove();

              let htmlData = '<div class="row">';
              let refNo = '';

              $.each(xpressLog, function (e, val) {

                let leftDiv = ''; let rightDiv = '';
                let styleDetails = 'style="color:#3649d5;cursor:pointer;"';
                if (refNo != val.ReferenceNumber) {
                  leftDiv += '<div><strong>' + 'ReferenceNo : ' + val.ReferenceNumber + '</strong></div>';
                  leftDiv += '<div><strong>' + 'Method : ' + val.ApiName + '</strong></div>';
                  leftDiv += '<div>' + 'Posted Date : ' + GlobalConstants.FromateDateWithTime(val.PostedDate) + '</div>';
                }
                else {
                  leftDiv += '';
                }
                if (GlobalConstants.isNullCheck(val.ArticleLink) != '') {
                  rightDiv += '<div>' + 'Link : <a href="' + val.ArticleLink + '" target="_blank">' + val.ArticleLink + '</a></div>';
                }

                if (GlobalConstants.isNullCheck(val.ResponseDate) != '') {
                  rightDiv += '<div>' + 'Response Date: ' + GlobalConstants.FromateDateWithTime(val.ResponseDate) + '</div>';
                }
                if (GlobalConstants.isNullCheck(val.Status) != '') {
                  rightDiv += '<div>' + 'Status : ' + val.Status + '</div>';
                }
                if (GlobalConstants.isNullCheck(val.StatusDuration) != '') {
                  rightDiv += '<div>' + 'Status Duration: ' + val.StatusDuration + '</div>';
                }
                rightDiv += '<hr/>';

                refNo = val.ReferenceNumber;


                htmlData += '<div style="float:right">' + leftDiv + '</div><hr/>';
                htmlData += '<div>' + rightDiv + '</div>';


              });

              htmlData += '</div>';
              let datahtml = '<tr><td>' + htmlData + '</td></tr>';;
              $('#tblLog tbody').append(datahtml);
            }
            else {
              $('#tblLog tbody tr').remove();
              let itemLogList = result.aArticleTransList;
              $.each(itemLogList,
                function (e, val) {
                  let tr = "<tr>";
                  tr += '<td>' + (e + 1) + '</td>';
                  tr += '<td>' + GlobalConstants.isNullCheck(val.ProcessName) + '</td>';
                  tr += '<td>' + GlobalConstants.isNullCheck(val.LoginName) + '</td>';
                  tr += '<td>' + GlobalConstants.FormatDateTime(val.transReceivedDate) + '</td>';
                  tr += '<td>' + GlobalConstants.FormatDateTime(val.CompletedDate) + '</td>';
                  tr += '</tr>';
                  $('#tblLog tbody').append(tr);
                });
            }

            //Previous Article Log Details
            $('#tbPrevLog tbody tr').remove();
            let itemPrevLogList = result.aArticlePrevTransList;
            $.each(itemPrevLogList,
              function (e, val) {
                $("#tabPrevLog").css("display", "");
                let tr = "<tr>";
                tr += '<td>' + (e + 1) + '</td>';
                tr += '<td>' + GlobalConstants.isNullCheck(val.ProcessName) + '</td>';
                tr += '<td>' + GlobalConstants.isNullCheck(val.LoginName) + '</td>';
                tr += '<td>' + GlobalConstants.FormatDateTime(val.transReceivedDate) + '</td>';
                tr += '<td>' + GlobalConstants.FormatDateTime(val.CompletedDate) + '</td>';
                tr += '</tr>';
                $('#tbPrevLog tbody').append(tr);

              });


            $('#tblNotesHistory tbody tr').remove();
            let itemNotesList = result.aNotesList;
            $.each(itemNotesList,
              function (e, val) {
                let tr = "<tr>";
                tr += '<td>' + (e + 1) + '</td>';
                tr += '<td>' + GlobalConstants.isNullCheck(val.CreatedBy) + '</td>';
                tr += '<td>' + GlobalConstants.isNullCheck(val.CreatedTime) + '</td>';
                tr += '<td>' + GlobalConstants.isNullCheck(val.Notes) + '</td>';

                if (GlobalConstants.isNullCheck(val.Attachment) != '' && GlobalConstants.isNullCheck(val.Attachment) != '/') {
                  tr += '<td>' + '<span><i class="bx bx-download notesfiledownload" style="font-size:18px; color:#556ee6; " title="Download" data-artId="' + GlobalConstants.isNullCheck(val.Id) + '"></i></span>&nbsp;' + '</td>';
                }
                else {
                  tr += '<td></td>';
                }
                tr += '</tr>';
                $('#tblNotesHistory tbody').append(tr);
              });

            $('.notesfiledownload').click(function () {
              let filePath = $(this).attr('data-artId');

              ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadNotesApi + '/' + filePath);
            });
            $('.ShowNotesInfo').click(function () {
              $('.titleNH').text(articleNo + ' Notes History');

              $('#myModal_NotesHistory').show();
            });

            $("#chkHoldRelease").prop("checked", false);
            $('#tblHoldHistory tbody tr').remove();
            let itemHoldReleaseList = result.aHoldReleaseList;

            $.each(itemHoldReleaseList,
              function (e, val) {
                let _queryText = ''; let _queryMailData = '';
                _queryText = GlobalConstants.isNullCheck(val.HoldBy);

                if (GlobalConstants.isNullCheck(val.QueryType) != '') {
                  if (val.QueryMode == 'Signal') {
                    _queryMailData += val.QueryType;
                  }
                  else if (GlobalConstants.isNullCheck(val.ToEmail) != '') {
                    _queryMailData += '<p>From Email : ' + GlobalConstants.isNullCheck(val.FromEmail) + '</p>';
                    _queryMailData += '<p>To Email : ' + GlobalConstants.isNullCheck(val.ToEmail) + '</p>';
                    _queryMailData += '<p>Cc Email : ' + GlobalConstants.isNullCheck(val.CCEmail) + '</p>';
                    _queryMailData += '<p>Bcc Email : ' + GlobalConstants.isNullCheck(val.BCCEmail) + '</p>';
                    _queryMailData += '<p>MailSubject : ' + GlobalConstants.isNullCheck(val.BCCEmail) + '</p>';
                  }
                }

                let tr = "<tr>";
                tr += '<td>' + (e + 1) + '</td>';
                if (val.InComplete) {
                  tr += '<td><strong>InComplete</strong> : ' + GlobalConstants.isNullCheck(val.HoldBy) + '</td>';
                }
                else {
                  tr += '<td>' + GlobalConstants.isNullCheck(val.HoldBy) + '</td>';
                }

                tr += '<td>' + GlobalConstants.FormatDate(val.HoldDate) + '</td>';
                tr += '<td>' + GlobalConstants.isNullCheck(val.HoldReason) + _queryMailData + '</td>';
                if (GlobalConstants.isNullCheck(val.HoldAttachment) != '') {
                  tr += '<td>' + '<span><i class="bx bx-download holdfiledownload" style="font-size:18px; color:#556ee6; " title="Download"  data-artId="' + GlobalConstants.isNullCheck(val.HoldAttachment) + '"></i></span>&nbsp;' + '</td>';
                }
                else {
                  tr += '<td></td>';
                }

                tr += '<td>' + GlobalConstants.isNullCheck(val.ReleaseBy) + '</td>';
                tr += '<td>' + GlobalConstants.FormatDate(val.ReleaseDate) + '</td>';
                tr += '<td>' + GlobalConstants.isNullCheck(val.ReleaseReason) + '</td>';
                if (GlobalConstants.isNullCheck(val.ReleaseAttachment) != '') {
                  tr += '<td>' + '<span><i class="bx bx-download holdfiledownload" style="font-size:18px; color:#556ee6; " title="Download"  data-artId="' + GlobalConstants.isNullCheck(val.ReleaseAttachment) + '"></i></span>&nbsp;' + '</td>';
                }
                else {
                  tr += '<td></td>';
                }
                tr += '</tr>';
                $('#tblHoldHistory tbody').append(tr);


                if (GlobalConstants.isNullCheck(val.ReleaseDate) == "" && GlobalConstants.isNullCheck(val.HoldDate) != "") {
                  $('#txtHold').val(GlobalConstants.isNullCheck(val.HoldReason));
                  $("#chkHoldRelease").prop("checked", true);
                }
                else {
                  if (!autoLoad) {
                    $('#txtHold').val("");
                  }
                }


              });

            $('.holdfiledownload').click(function () {
              var filePath = $(this).attr('data-artId');

              ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadHrApi + '/' + localStorage.aEID + '/' + filePath.replace(".zip", ""));
            });
            $('.ShowHoldInfo').click(function () {
              let _title = $(this).attr('title');
              $('.titleHRH').text(_title + ' History ' + articleNo);
              $('#myModal_HoldReleaseHistory').show();
            });

            $('#chkHoldRelease').change(function () {
              ArticleinfoComponent.ShowHoldReleasePopUp(articleNo);
            });

            $('#chkFirstRelease').change(function () {
              if ($('#chkFirstRelease').prop('checked') == true) {

                if (standardFR == true) {
                  ngswal({
                    title: "Standard First Release was already sent. Are you sure to send On-demand First Release?",
                    text: "On-demand First Release Confirmation !",
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: false,
                    closeOnCancel: false
                  },
                    function (isConfirm) {
                      if (isConfirm) {
                        ngswal({
                          title: 'Please wait processing!.....',
                          text: '',
                          showCancelButton: false,
                          showConfirmButton: false
                        });
                        $('#btnOndemandFirstRelease').trigger("click");
                      } else {
                        ngswal("Cancelled", "You clicked cancel! :)", "warning");
                        $('#chkFirstRelease').prop('checked', false);
                      }
                    });
                }
                else {
                  ngswal({
                    title: "Are you sure you want to publish an on-demand first release for this article?",
                    text: "On-demand First Release Confirmation !",
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: false,
                    closeOnCancel: false
                  },
                    function (isConfirm) {
                      if (isConfirm) {
                        ngswal({
                          title: 'Please wait processing!.....',
                          text: '',
                          showCancelButton: false,
                          showConfirmButton: false
                        });
                        $('#btnOndemandFirstRelease').trigger("click");
                      } else {
                        ngswal("Cancelled", "You clicked cancel! :)", "warning");
                        $('#chkFirstRelease').prop('checked', false);
                      }
                    });
                }
              }
            });


            //FirstRelease package download
            $('.FirstDownload').click(function () {
              let artId = $(this).attr('data-artId');
              let packageName = $(this).attr('data-package');
              ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadWfApi + '/' + artId + '/' + packageName);
            });
            if (holdReleaseRights == "Yes") {
              $("#chkHoldRelease").css("display", "");
            }
            else {
              $("#chkHoldRelease").css("display", "none");
            }
            if (egRights == "Yes") {
              $(".egApprove").css("display", "");
            }
            else {
              $(".egApprove").css("display", "none");
            }
            if (eptRights == "Yes") {
              $(".eptApprove").css("display", "");
            }
            else {
              $(".eptApprove").css("display", "none");
            }

            if (reviewRights == "Yes") {
              $(".articleReview").css("display", "");
            }
            else {
              $(".articleReview").css("display", "none");
            }
            if (correctionRights == "Yes") {
              $(".FPPG").css("display", "");
              $(".FPPGPendingReallocate").css("display", "");
              $(".ManualPG").css("display", "");
              $(".ManualPGPendingReallocate").css("display", "");
            }
            else {
              $(".FPPG").css("display", "none");
              $(".FPPGPendingReallocate").css("display", "none");
              $(".ManualPG").css("display", "none");
              $(".ManualPGPendingReallocate").css("display", "none");
            }
            if (finalCorrectionRights == "Yes") {
              $(".PCPG").css("display", "");
              $(".PCPGPendingReallocate").css("display", "");
            }
            else {
              $(".PCPG").css("display", "none");
              $(".PCPGPendingReallocate").css("display", "none");
            }
            if (QCRights == "Yes") {
              $(".FPQC").css("display", "");
              $(".FPQCPendingReallocate").css("display", "");
              $(".QCApprove").css("display", "");
              $(".QCCorrection").css("display", "");
            }
            else {
              $(".FPQC").css("display", "none");
              $(".FPQCPendingReallocate").css("display", "none");
              $(".QCApprove").css("display", "none");
              $(".QCCorrection").css("display", "none");
            }
            if (approveArticleRights == "Yes") {
              $(".articleApprove").css("display", "");
              $(".articleCorrection").css("display", "");
              $(".AtypeonUpload").css("display", "");
              $(".PCReady").css("display", "");
              $(".PCPendingReallocate").css("display", "");
              $(".Atypeon").css("display", "");
            }
            else {
              $(".articleApprove").css("display", "none");
              $(".articleCorrection").css("display", "none");
              $(".AtypeonUpload").css("display", "none");
              $(".PCReady").css("display", "none");
              $(".PCPendingReallocate").css("display", "none");
              $(".Atypeon").css("display", "none");
            }

            $('#divLoading').hide(); $('#divArtInfo').show();

            $("#LoadingImagePopupInfo").hide();

            //download file if page is refresh
            //if (downloadFile == true) {
            //  $('#btnDownload').trigger("click");
            //}
          }
          if (localStorage.metadataEdit == 'false') {
            $("#divArtInfo :input:not(:checkbox)").attr("disabled", true);
            $("#divArticleModule :input").attr("disabled", true);
            $('#btnMetaUpdate').hide(); $('#btnReopen').hide();

            $(".skipDisabled :input").removeAttr("disabled");

          }

          if (onDemandXML || !onDemandFromVendor) {
            $("#chkFirstRelease").attr("disabled", true);
          }
          else {
            $("#chkFirstRelease").attr("disabled", false);
          }

          if (itemL[0].IsHold === true) {
            $(".FPPG,.FPPGPendingReallocate,.ManualPG,.ManualPGPendingReallocate,.PCPG,.PCPGPendingReallocate").hide();
            $(".FPQC,.FPQCPendingReallocate,.QCApprove,.QCCorrection,.articleApprove,.articleCorrection").hide();

            $('.publishCheck,.fileCorrection,.revisedfileApprove,.proofApprove,.ProofingEPTApprove,.ProofingEPTCorrection').hide();
            $('.ProofingEPTOneMoreReview,.fileApprove,.articleReview,.articleReviewSignal').hide();

            $(".AtypeonUpload,.PCReady,.PCPendingReallocate,.Atypeon").hide();
            $("#chkFirstRelease").attr("disabled", true);
          }

        }

      },
      error => {
        $("#LoadingImagePopupInfo").hide();
        if (!autoLoad) {
          ngswal("Failed !", error.message, "warning");
        }
      }
    );
  }

  //General Function for Article Approval
  static ArticleApproval(): void {
    ngswal({
      title: "Do you want to approve the article for next stage?",
      text: "Article Approve Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });

          $('#myModal_Delay').hide();
          $('#myModal_CID').hide();
          $('#myModal_JrlNotes').hide();
          $('#myModal_ApproveAttach').hide();
          $('#myModal_PubDate').hide();

          $('#btnApprove').trigger("click");
        } else {
          ngswal("Cancelled", "You clicked cancel! :)", "warning");
        }
      });
  }

  showFirstReleasePopUp(): void {
    //if ($('#chkFirstRelease').prop('checked') == true) {
    //  this.uploadFile();
    //}
  }

  showHoldInfo() {
    this.showHoldHistoryModal = true;
  }

  hideHoldHistoryModal(): void {
    $('#myModal_HoldReleaseHistory').hide();
  }

  mailToTrigger() {
    if ($('#ddlMailTo').val() == '0') {
      $('#TxtMailTo').val('');
    }
    else {
      $('#TxtMailTo').val($('#ddlMailTo').val());

      var articleData = {
        ArticleId: localStorage.aEID,
        EmailId: $('#ddlMailTo').val()
      };
      ApiMethod.postMethod(ArticleinfoComponent.modelItem.proofingEmailTemplateApi, articleData).subscribe(
        result => {
          let itemProof = result.aProofingTemplateItem;
          if (itemProof != null) {
            $('#TxtMailCC').val(itemProof[0].CC);

            $('#TxtMailBCC').val(itemProof[0].BCCEmail);

            $('#myModal_Review #TxtMailSubject').val(itemProof[0].MailSubject);

            $('#myModal_Review #Divmail .jqte_editor').html(itemProof[0].MailBody);

            $('#myModal_Review #TxtConfirmationMailSubject').val(itemProof[0].AckMailSubject);

            $('#myModal_Review #DivConfirmail .jqte_editor').html(itemProof[0].ConfirmationMailbody);
          }
        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
  }

  reallocate() {
    ArticleinfoComponent.GetAllocateOption(ArticleinfoComponent.aartId, ArticleinfoComponent.aproofId,
      ArticleinfoComponent.aactivityId, ArticleinfoComponent.afileSno);
  }


  GetPopulateQueryType() {
    try {
      var selectedQuery = ArticleinfoComponent.queryTypeList.filter(a => a.QueryType == $('#ddlQueryType').val());
      if (selectedQuery.length > 0) {
        $('#txtQueryFromEmail').val(selectedQuery[0].FromEmail);
        $('#txtQueryToEmail').val(selectedQuery[0].ToEmail);
        $('#txtQueryCcEmail').val(selectedQuery[0].CCEmail);
        $('#txtQueryBccEmail').val(selectedQuery[0].BCCEmail);

        $('#txtQuerySubject').val(selectedQuery[0].MailSubject);

        //$('#txtQueryMailBody').val(selectedQuery[0].MailBody);
        $('#divQueryMailBodyPanel .jqte_editor').html(selectedQuery[0].MailBody);
      }
    } catch (e) {

    }
  }

  ChangeHoldType(holdType): void {
    let titleTxt = $('.titleHR').text();
    $('.titleHR').text(titleTxt.split(' ')[0] + ' ' + holdType);

    if (holdType == 'InComplete') {
      $('#LblHoldText').text("Remarks");
    }
    else {
      $('#LblHoldText').text("On Hold Notes");
    }

    if (ArticleinfoComponent.holdType == 'Release' && holdType == 'Hold') {
      $('.titleHR').text(titleTxt.split(' ')[0] + ' Release');
      $("#divDueDateRelease").css("display", "block");
    }

    $('#divLeftPanel').attr('class', 'col-12');
    //$('#divHoldTypeOption').attr('class', 'col-2');
    $('.divHoldContent').css("display", "block"); $('.divQueryContent').css("display", "none");
    if (holdType == 'Query' || holdType == 'Notification') {
      $("#divDueDateRelease").css("display", "none");
      $('#lblQueryType').html(holdType + ' Type');

      $('.divHoldContent').css("display", "none");
      $('.divQueryContent').css("display", "block");
      $('#divHoldTypeOption').attr('class', 'col-12');
      $('#divLeftPanel').attr('class', 'col-5');

      //Check Query Signal only or Send mail notificiation
      let dataList = ArticleinfoComponent.queryTypeList.filter(a => a.QueryMode == 'Query' && a.IsNotification == false);
      if (dataList.length == 0) {
        $('.divQueryMail').hide();
        $('#divLeftPanel').attr('class', 'col-12');

        dataList = ArticleinfoComponent.queryTypeList.filter(a => a.QueryMode == 'Signal' && a.IsNotification == false);
      }

      if (holdType == 'Notification') {
        dataList = ArticleinfoComponent.queryTypeList.filter(a => a.IsNotification == true);
      }

      $("#ddlQueryType").empty();
      $('#ddlQueryType').append('<option value="Select">Select</option>');
      $.each(dataList, function (e, val) {
        $('#ddlQueryType').append('<option value="' + val.QueryType + '">' + val.QueryType + '</option>');
      });

    }
  }

  static ShowHoldReleasePopUp(articleNo): void {
    //if (!ArticleinfoComponent.pasteHtmlTextClear) {
    //  $(".jqte_editor").on("paste", function (e) {
    //    e.preventDefault();
    //    var text = e.originalEvent.clipboardData.getData('text');
    //    // insert copied data @ the cursor location
    //    document.execCommand("insertText", false, text);
    //    e.preventDefault();
    //    ArticleinfoComponent.pasteHtmlTextClear = true;
    //  });
    //}

    $('#TabulHoldTab a[href="#Hold"]').trigger('click');
    $('#divLeftPanel').attr('class', 'col-12');
    //$('#divHoldTypeOption').attr('class', 'col-2');
    $('.divHoldContent').css("display", "block");
    $('.divQueryContent').css("display", "none");

    $('.divQueryContent input,#txtRelease').val('');
    $('.divQueryContent textarea').val('');
    $('#FU_HRAttchment').val('');
    $('#divQueryMailBodyPanel .jqte_editor').html('');


    //$('#divHoldTypeOption').css("display", "none");
    $('#divQueryMailBodyPanel .jqte_editor').css({ 'height': (GlobalConstants.size.height - 240), 'resize': 'none' });

    if ($('#chkHoldRelease').prop('checked')) {
      ArticleinfoComponent.holdType = "Hold";
      ArticleinfoComponent.showRelease = false;
      $("#divRelease").css("display", "none");
      $("#divDueDateRelease").css("display", "none");
      $('#txtHold').removeAttr("disabled");
    }
    else {
      ArticleinfoComponent.holdType = "Release";
      ArticleinfoComponent.showRelease = true;
      $("#divRelease").css("display", "block");
      $("#divDueDateRelease").css("display", "block");
      $('#txtHold').attr("disabled", true);
    }

    $('.titleHR').text(articleNo + ' ' + ArticleinfoComponent.holdType);

    $("#LoadingImageHoldRelease").show();
    ApiMethod.getMethod(ArticleinfoComponent.modelItem.getQueryTypeList + '/' + localStorage.aPubID + '/' + localStorage.aEID).subscribe(
      resonse => {
        if (resonse.Status == "Success") {
          let dataList = resonse.DataItem;
          let queryMode = resonse.QueryMode;

          ArticleinfoComponent.queryTypeList = dataList;


          let _dataList = dataList.filter(a => a.IsNotification == true);
          if (_dataList.length > 0) {
            $('#liNotification').show();
          }

          if (dataList != null) {
            if (dataList.length > 0) {
              $('#divHoldTypeOption').css("display", "block");
            }
            else {
              $('#divHoldTypeOption').css("display", "none");
            }
            //Check Query Signal only or Send mail notificiation
            var checkQueryMailBased = dataList.filter(a => a.QueryMode == 'Query');
            if (checkQueryMailBased.length == 0) {
              $('.divQueryMail').hide();
              $('#divLeftPanel').attr('class', 'col-12');
            }
          }

          if (queryMode == "InComplete") {
            $('#LblHoldText').text("Remarks");
            $('.holdGenTab').hide();
            $('#TabulHoldTab a[name="InComplete"]').trigger('click');
          }
          else {
            $('.holdGenTab').show();
          }

        }
        else {
          console.log(resonse);
        }
        $('#myModal_HoldRelease').show();
        $("#LoadingImageHoldRelease").hide();
      },
      error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImageHoldRelease").hide();
      }
    );

  }


  hideHoldModal(): void {
    ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
    if ($('#chkHoldRelease').prop('checked') == true) {
      $('#chkHoldRelease').prop('checked', false);
    }
    else {
      $('#chkHoldRelease').prop('checked', true);
    }
    $('#myModal_HoldRelease').hide();
    this.showHoldModal = false;
  }

  updateHoldRelease(): void {
    let holdType = $('#TabulHoldTab .nav-link.active')[0].name;
    let idInput = (<HTMLInputElement>document.getElementById('FU_HRAttchment')).files;
    if ((ArticleinfoComponent.holdType == "Hold") && ($('#txtHold').val().trim() == "") && holdType == 'Hold') {
      ngswal("Warning !", "Please enter some notes and save or click cancel to close !", "warning");
    }
    else if ((ArticleinfoComponent.holdType == "Release") && ($('#txtRelease').val().trim() == "") && holdType == 'Hold') {
      ngswal("Warning !", "Enter Response !", "warning");
    }
    else if (holdType == 'Query' && $('#ddlQueryType').val() == 'Select') {
      ngswal("Warning !", "Please Select Query Type !", "warning");
    }
    else if (holdType == 'Notification' && $('#ddlQueryType').val() == 'Select') {
      ngswal("Warning !", "Please Select Notificaiton Type !", "warning");
    }
    else {
      $("#LoadingImageHoldRelease").show();
      var hrFileName = "";
      if (idInput.length > 0) {
        hrFileName = idInput[0].name;

      }
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });

      let _queryMailBody = $("#txtQueryMailBody").val().trim();

      if (_queryMailBody == '') {
        _queryMailBody = $('#divQueryMailBodyPanel .jqte_editor').html().trim();
      }

      var aArticleItemL = {
        ArticleId: localStorage.aEID,
        HoldInfo: $('#txtHold').val(),
        ReleaseInfo: $('#txtRelease').val(),
        HoldType: ArticleinfoComponent.holdType,
        LoginId: localStorage.aLoginID,
        fileAsBase64: this.fileBase64,
        fileName: hrFileName,
        QueryType: $('#ddlQueryType').val(),
        QueryTypeMode: holdType,
        FromEmail: $('#txtQueryFromEmail').val(),
        ToEmail: $('#txtQueryToEmail').val(),
        CCEmail: $('#txtQueryCcEmail').val(),
        BCCEmail: $('#txtQueryBccEmail').val(),
        MailSubject: $('#txtQuerySubject').val(),
        MailBody: _queryMailBody,
        dueDate: $('#Txt_HoldDueDate').val()
      }
      //const formData = new FormData();
      //for (let i = 0; i < idInput.length; i++) {
      //  formData.append('files', idInput[i]);
      //}
      //formData.append('dataparam', JSON.stringify(aArticleItemL));

      ApiMethod.postMethod(ArticleinfoComponent.modelItem.updateHoldReleaseApi, aArticleItemL).subscribe(
        resonse => {

          $("#LoadingImageHoldRelease").hide();
          if (resonse.status == "Failed") {
            ngswal("Failed!", resonse.message, "warning");
          }
          else {
            this.showHoldModal = false;
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Updated !",
              text: holdType + ' updated succesfully',
              showConfirmButton: false,
              timer: 1500
            });
            ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
            $('#myModal_HoldRelease').hide();
            if ($("#btnLoadList").length > 0) {
              $("#btnLoadList").trigger("click");
            }
          }
        },
        error => {
          console.log(error);
          ngswal("Failed!", error, "warning");
          $("#LoadingImageHoldRelease").hide();
        }
      );
    }
  }

  showNotesPopUp(): void {
    this.articleNotes = localStorage.aEID + ' Notes';
    this.showNotesModal = true;
  }

  hideNotesModal(): void {
    $('#myModal_GeneralNotes').hide();
  }

  hideNotesHistoryModal(): void {
    $('#myModal_NotesHistory').hide();
  }



  //Update Article Notes
  updateArticleNotes(type = ''): void {
    let idInput = (<HTMLInputElement>document.getElementById('FU_NotesAttchment')).files;
    if ($('#TxtGeneralNote').val().trim() == '' && type != 'Clear') {
      ngswal("Warning !", "Please enter some notes and save or click cancel to close !", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var hrFileName = "";
      if (idInput.length > 0) {
        hrFileName = idInput[0].name;

      }
      var aArticleItemL = {
        ArticleId: localStorage.aEID,
        Notes: $('#TxtGeneralNote').val(),
        LoginId: localStorage.aLoginID,
        fileAsBase64: this.fileBase64,
        fileName: hrFileName
      }
      let aItemP = JSON.stringify(aArticleItemL);

      ApiMethod.postMethod(ArticleinfoComponent.modelItem.updateNotesApi, aItemP).subscribe(
        resonse => {
          $("#LoadingImagePopup").hide();
          if (type != 'Clear') {
            if (resonse.status == 'Failed') {
              ngswal({
                position: "top-end",
                type: "error",
                title: "Error!",
                text: resonse.message,
                showConfirmButton: false,
                timer: 1500
              });
            }
            else {
              ngswal({
                position: 'top-end',
                type: "success",
                title: "Updated !",
                text: resonse.message,
                showConfirmButton: false,
                timer: 1500
              });
              this.showNotesModal = false; this.hideNotesModal();
              $('#spNotes').html($('#TxtGeneralNote').val());
              $('#TxtGeneralNote').val("");
              $('#FU_NotesAttchment').val("");
              ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
            }

          }
          else {
            $('#TxtGeneralNote').val("");
            $('#FU_NotesAttchment').val("");
          }

        },
        error => {
          console.log(error);
          ngswal("Failed!", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  clearArticleNotes(): void {
    $('#TxtGeneralNote').val("");
    $('#FU_NotesAttchment').val("");
    //this.updateArticleNotes('Clear');
  }

  downloadProofFile(artId, proofId) {
    ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadWfApi + '/' + artId + '/' + proofId);
  }

  downloadFrFile(artId, fileName) {
    ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadWfApi + '/' + artId + '/' + fileName.replace(".zip", ""));
  }

  firstReleaseRequest() {
    $("#LoadingImage").show();

    var aItemP = {
      ArticleID: localStorage.aEID,
      Createdby: localStorage.aLoginID
    }

    ApiMethod.postMethod(ArticleinfoComponent.modelItem.firstReleaseRequestApi, aItemP).subscribe(
      response => {
        if (response.status == "Failed") {
          ngswal({
            position: "top-end",
            type: "error",
            title: "Error!",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          ngswal({
            position: "top-end",
            type: "success",
            title: "Uploaded!",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
        }
        ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        ngswal("Failed!", error, "warning");
        $("#LoadingImagePopup").hide();
      }
    );

  }

  articleCorrection() {
    $('div[name="correctionPopup"] input').val('');
    customfunctions.SetTodayDateValues("#Txt_DueDate");
    this.showCorrectionModal = true;
  }

  hideCorrectionModal() {
    $('#myModal_Corrections').hide();
  }
  hideEPTCorrectionModal() {
    $('#myModal_EPTCorrections').hide();
  }
  approveQcConfirm() {
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      ActivityId: localStorage.ActivityId
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.approveQcApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Approved !",
            text: result.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.AutoEgTrigger();
        } else {
          ngswal("Failed !", result.message, "warning");
        }
        ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error, "warning");
      });
  }

  updateArticleCorrection() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_Attchment')).files;
    var insElementExists = document.getElementById("TxtInstruction");
    var UpElementExists = document.getElementById("FU_Attchment");
    var ins = "Yes";
    var up = "Yes";
    if (insElementExists != null) {
      if ($('#TxtInstruction').val() == "") {
        ins = "No";
      }
    }
    if (UpElementExists != null) {
      if (idInput.length == 0) {
        up = "No";
      }
    }
    if ((ins == "No") && (up == "No")) {
      ngswal("Warning !", "Please enter instructions or upload a marked-up file to proceed with the correction !", "warning");
    }
    else if ($('#ddlCorrTypeXmlPdf').val() == 'Xml' && $('#Txt_EpubDateCorrection').val() == '') {
      ngswal("Warning !", "Please Select EPub Date!", "warning");
    }
    else {

      $("#LoadingImagePopup1").show();
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (UpElementExists != null) {
        if (idInput.length > 0) {
          file.fileName = idInput[0].name;
          file.fileSize = idInput[0].size;
        }
        else {
          file.fileName = "";
          file.fileSize = 0;
        }
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }

      if ($('#ddlCorrTypeXmlPdf').val() != 'Select') {
        file.correctionTypeXmlPdf = $('#ddlCorrTypeXmlPdf').val();
        file.epubDate = $('#Txt_EpubDateCorrection').val();
      }

      file.vendorConfigID = localStorage.aEID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = $('#ddlCorrectionType').val();
      file.id = localStorage.aEID;
      file.entryType = "";
      if (insElementExists != null) {
        file.instruction = $('#TxtInstruction').val();
      }
      else {
        file.instruction = "";
      }
      file.dueDate = $('#Txt_DueDate').val();
      if (UpElementExists != null) {
        file.fileAsBase64 = this.fileBase64;
      }
      else {
        file.fileAsBase64 = "";
      }
      file.ProcessId = localStorage.ActivityId;
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      ApiMethod.postMethod(ArticleinfoComponent.modelItem.uploadCorrectionApi, file).subscribe(
        resonse => {
          $("#myModal_Corrections").hide();
          if (resonse.status == "Failed") {
            ngswal("Failed !", resonse.message, "warning");
          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          $("#LoadingImagePopup1").hide();
        },
        error => {
          console.log(error);
          ngswal("Failed !", error, "warning");
          $("#LoadingImagePopup1").hide();
        }
      );

    }

  }

  fileChangeEvent(fileInput: any) {
    this.MsgCorrectionError = '';
    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  fileEPTChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  RefNoteFileChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  hideQCCorrectionModal() {
    $('#myModal_QCCorrections').hide();
  }
  hideAtypeonCorrectionModal() {
    $('#myModal_AtypeonCorrections').hide();
  }
  updateQCCorrection() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_QCAttchment')).files;
    if ((idInput.length == 0) && ($('#TxtQCInstruction').val().trim() == "")) {
      ngswal("Warning !", "Please enter instructions or upload a marked-up file to proceed with the correction !", "warning");
    }
    else {
      $("#LoadingImagePopupQC").show();
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (idInput.length > 0) {
        file.fileName = idInput[0].name;
        file.fileSize = idInput[0].size;
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.vendorConfigID = localStorage.aEID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = "Correction";
      file.id = localStorage.aEID;
      file.entryType = "";
      file.instruction = $('#TxtQCInstruction').val().trim();
      file.dueDate = '';
      file.fileAsBase64 = this.fileBase64;

      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });

      ApiMethod.postMethod(ArticleinfoComponent.modelItem.uploadQcCorrectionApi, file).subscribe(
        resonse => {
          $("#myModal_QCCorrections").hide();
          if (resonse.status == "Failed") {
            ngswal({
              position: "top-end",
              type: "error",
              title: "Error!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }

          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          $("#LoadingImagePopupQC").hide();
        },
        error => {
          ngswal("Failed !", error, "warning");
          $("#LoadingImagePopupQC").hide();
        }
      );

    }

  }

  updateAtypeonCorrection() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_AtypeonAttchment')).files;
    if (idInput.length == 0) {
      ngswal("Warning !", "Select file!", "warning");
    }
    else {
      $("#LoadingImagePopupAtypeon").show();
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (idInput.length > 0) {
        file.fileName = idInput[0].name;
        file.fileSize = idInput[0].size;
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.vendorConfigID = localStorage.aEID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = "Correction";
      file.id = localStorage.aEID;
      file.entryType = "";
      file.instruction = "";
      file.dueDate = '';
      file.fileAsBase64 = this.fileBase64;

      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      ApiMethod.postMethod(ArticleinfoComponent.modelItem.uploadAtypeonCorrectionApi, file).subscribe(
        resonse => {
          $("#myModal_AtypeonCorrections").hide();
          console.log(resonse.status + resonse.message);
          if (resonse.status == "Failed") {
            ngswal({
              position: "top-end",
              type: "error",
              title: "Error!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          $("#LoadingImagePopupAtypeon").hide();
        },
        error => {
          console.log(error);
          ngswal("Failed !", error, "warning");
          $("#LoadingImagePopupAtypeon").hide();
        }
      );

    }

  }

  fileNotesChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  fileHRChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  fileQCChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  fileAtypeonChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  fileApproveAttachChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  articleApprove() {
    if ($('#TxtPopVolume').val() == '' || $('#TxtPopVolume').val() == '0') {
      ngswal("Warning !", "Enter Volume!", "warning");
      $('#LoadingImage').hide();
    }
    else if ($('#TxtPopIssue').val() == '' || $('#TxtPopIssue').val() == '0') {
      ngswal("Warning !", "Enter Issue!", "warning");
      $('#LoadingImage').hide();
    }
    else {
      ngswal({
        title: "Do you want to approve the article for publication on Atypon staging?",
        text: "Article Approve Confirmation !",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        closeOnConfirm: false,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            $('#btnApprove').trigger("click");
          } else {
            ngswal("Cancelled", "You clicked cancel! :)", "warning");
          }
        });
    }

  }

  revisedFileapproveConfirm() {
    $('#LoadingImage').show();

    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      Volume: $('#TxtPopVolume').val(),
      Issue: $('#TxtPopIssue').val(),
      ActivityId: localStorage.ActivityId
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.revisedFileApproveApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        if (result.status != 'Failed') {
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          ngswal("Info !", result.message, "success");
          //this.atyponUpload();
        } else {
          ngswal("Failed !", result.message.substr(0, 1000), "warning");
        }
        if ($("#btnRefreshLoadData").length > 0) {
          $("#btnRefreshLoadData").trigger("click");
        }

        if ($("#btnLoadList").length > 0) {
          $("#btnLoadList").trigger("click");
        }

      }, error => {
        console.log(error);
        $("#LoadingImage").hide();
        ngswal("Failed !", error, "warning");
      });
    //}

    $('#LoadingImage').hide();
  }

  proofingApproveConfirm() {
    $('#LoadingImage').show();

    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      Volume: $('#TxtPopVolume').val(),
      Issue: $('#TxtPopIssue').val(),
      ActivityId: localStorage.ActivityId
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.proofingApproveApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        if (result.status != 'Failed') {
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          ngswal("Info !", result.message, "success");
          //this.atyponUpload();
        } else {
          ngswal("Failed !", result.message.substr(0, 1000), "warning");
        }
        if ($("#btnRefreshLoadData").length > 0) {
          $("#btnRefreshLoadData").trigger("click");
        }
      }, error => {
        console.log(error);
        $("#LoadingImage").hide();
        ngswal("Failed !", error, "warning");
      });
    //}

    $('#LoadingImage').hide();
  }

  oneMoreReviewSignalConfirm() {
    $('#LoadingImage').show();

    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      ActivityId: localStorage.ActivityId
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.oneMoreReviewSignalApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        if (result.status != 'Failed') {
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          ngswal("Info !", result.message, "success");
          $('#myModal_MailPreview').hide();
        } else {
          ngswal("Failed !", result.message.substr(0, 1000), "warning");
        }
        if ($("#btnRefreshLoadData").length > 0) {
          $("#btnRefreshLoadData").trigger("click");
        }
      }, error => {
        console.log(error);
        $("#LoadingImage").hide();
        ngswal("Failed !", error, "warning");
      });
    //}

    $('#LoadingImage').hide();
  }

  ApproveAttachConfirm() {
    ngswal({
      title: "Approval Confirmation !",
      text: "Do you want to approve the article?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {

          $('#myModal_ApproveAttach').hide();

          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('#btnApprove').trigger("click");

        } else {
          ngswal("Cancelled", "You clicked cancel! :)", "warning");
        }
      });
  }

  approveConfirm() {
    $('#LoadingImage').show();

    let idInput = (<HTMLInputElement>document.getElementById('FU_ApproveAttchment')).files;

    var hrFileName = "";
    if (idInput.length > 0) {
      hrFileName = idInput[0].name;
    }

    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      Volume: $('#TxtPopVolume').val(),
      Issue: $('#TxtPopIssue').val(),
      ActivityId: localStorage.ActivityId,
      DOICID: $('#TxtCID').val(),
      PubDate: $('#Txt_PublDate').val(),
      EPubDate: $('#TxtPopEpubDate').val(),
      ApprovalType: localStorage.ApprovalType,
      DelayReason: $('#TxtDelayReason').val(),
      FileAsBase64: this.fileBase64,
      FileName: hrFileName,
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.approveApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        if (result.status != 'Failed') {
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          ngswal("Info !", result.message, "success");

          //this.atyponUpload();
        } else {
          ngswal("Failed !", result.message.substr(0, 1000), "warning");
        }
        if ($("#btnRefreshLoadData").length > 0) {
          $("#btnRefreshLoadData").trigger("click");
        }
      }, error => {
        console.log(error);
        $("#LoadingImage").hide();
        ngswal("Failed !", error, "warning");
      });
    //}

    $('#LoadingImage').hide();
  }

  proofingEPTApproveConfirm() {
    console.log(ArticleinfoComponent.modelItem.proofingEPTApproveApi);
    $('#LoadingImage').show();
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      Volume: $('#TxtPopVolume').val(),
      Issue: $('#TxtPopIssue').val(),
      ActivityId: localStorage.ActivityId
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.proofingEPTApproveApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        if (result.status != 'Failed') {
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          ngswal({
            position: "top-end",
            type: "success",
            title: "Uploaded !",
            text: "Proofing process next stage",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          ngswal("Failed !", result.message.substr(0, 1000), "warning");
        }
        if ($("#btnRefreshLoadData").length > 0) {
          $("#btnRefreshLoadData").trigger("click");
        }
      }, error => {
        console.log(error);
        $("#LoadingImage").hide();
        ngswal("Failed !", error, "warning");
      });
    //}

    $('#LoadingImage').hide();
  }

  updateProofingEPTCorrection() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_EPTAttchment')).files;
    var insElementExists = document.getElementById("TxtEPTInstruction");
    var UpElementExists = document.getElementById("FU_EPTAttchment");
    var ins = "Yes";
    var up = "Yes";
    if (insElementExists != null) {
      if ($('#TxtInstruction').val() == "") {
        ins = "No";
      }
    }
    if (UpElementExists != null) {
      if (idInput.length == 0) {
        up = "No";
      }
    }
    if ((ins == "No") && (up == "No")) {
      ngswal("Warning !", "Please enter instructions or upload a marked-up file to proceed with the correction !", "warning");
    }
    else {
      $("#LoadingImagePopupEPTCorrection").show();
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (UpElementExists != null) {
        if (idInput.length > 0) {
          file.fileName = idInput[0].name;
          file.fileSize = idInput[0].size;
        }
        else {
          file.fileName = "";
          file.fileSize = 0;
        }
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.vendorConfigID = localStorage.ActivityId;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = "Correction";
      file.id = localStorage.aEID;
      file.ArticleID = localStorage.aEID;
      file.entryType = "";
      if (insElementExists != null) {
        file.instruction = $('#TxtEPTInstruction').val();
      }
      else {
        file.instruction = "";
      }

      file.dueDate = '';
      file.fileAsBase64 = this.fileBase64;

      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });

      try {
        ApiMethod.postMethod(ArticleinfoComponent.modelItem.uploadProofingEPTCorrectionApi, file).subscribe(
          resonse => {
            console.log(resonse.status);
            if (resonse.status == "Failed") {
              ngswal("Failed !", resonse.message, "warning");
            }
            else {
              $("#myModal_EPTCorrections").hide();
              ngswal({
                position: "top-end",
                type: "success",
                title: "Correction Uploaded !",
                text: resonse.message,
                showConfirmButton: false,
                timer: 1500
              });
            }
            ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
            $("#LoadingImagePopupEPTCorrection").hide();
          },
          error => {
            console.log(error);
            ngswal("Failed !", 'Correction Uploaded', "warning");
            ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
            $("#LoadingImagePopupEPTCorrection").hide();
          }
        );
      } catch (e) {
        console.log(e);
        //ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
      }

    }

  }

  atyponUpload() {
    var aItemL =
    {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      AtyponType: 'Article'
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.atyponUploadApi, aItemL).subscribe(
      result => {
        console.log('' + result);
        if ($("#btnRefreshLoadData").length > 0) {
          $("#btnRefreshLoadData").trigger("click");
        }
      }
    );
  }
  articleReview() {
    var articleData = {
      ArticleId: localStorage.aEID
    };
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.articleByIdApi, articleData).subscribe(
      result => {
        let itemAuthor = result.aAuthorItem;
        this.lAuthorList = itemAuthor;
      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );
    this.showReviewModal = true;

  }

  oneMoreReviewConfirm() {
    $('#LoadingImagePopup2').show();

    let _mailBody = $("#TxtMailBody").val().trim();
    let _confirMailBody = $("#TxtConfirmationMailBody").val().trim();

    if (_mailBody == '') {
      _mailBody = $('#Divmail .jqte_editor').html().trim();
    }
    if (_confirMailBody == '') {
      _confirMailBody = $('#DivConfirmail .jqte_editor').html().trim();
    }

    if (_mailBody == '' || _confirMailBody == '') {
      ngswal("Failed !", 'Failed to fetch Mailbody or Confirmation Mailbody', "warning");
    }
    else {
      var aItemL =
      {
        LoginId: localStorage.aLoginID,
        ArticleId: localStorage.aEID,
        MailTo: $('#TxtMailTo').val(),
        MailCC: $('#TxtMailCC').val(),
        MailBCC: $('#TxtMailBCC').val(),
        MailBody: _mailBody,
        MailSubject: $('#TxtMailSubject').val(),
        Signature: "",
        ConfirmationMailBody: _confirMailBody,
        ConfirmationMailSubject: $('#TxtConfirmationMailSubject').val(),
        ActivityId: localStorage.ActivityId
      }
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      ApiMethod.postMethod(ArticleinfoComponent.modelItem.oneMoreReviewApi, aItemL).subscribe(
        result => {
          if (result.status) {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Sent !",
              text: result.message,
              showConfirmButton: false,
              timer: 1500
            });
            $('#myModal_Review').hide();
          }
          else {
            ngswal("Failed !", result.message, "warning");
          }
        }, error => {

          ngswal("Failed !", error.message, "warning");
        });
    }

  }
  hideAtypeonHistoryModal() {
    $('#myModal_AtypeonHistory').hide();
  }
  hideReviewModal() {
    $('#myModal_Review').hide();
  }

  AutoEgTrigger() {
    $('.egApprove').attr("disabled", 'disabled');
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.egApprove, aItemL).subscribe(
      resonse => {
        $('.egApprove').removeAttr('disabled', 'disabled');
        console.log(resonse.message);
        if ($("#btnRefreshLoadData").length > 0) {
          $("#btnRefreshLoadData").trigger("click");
        }
      }
    );
  }

  egTrigger() {
    $("#LoadingImage").show();
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.egApprove, aItemL).subscribe(
      resonse => {
        if (resonse.status.toLowerCase() == 'failed') {
          ngswal("Failed!", resonse.message, "warning");
        }
        else {
          ngswal({
            position: 'top-end',
            type: "success",
            title: resonse.message,
            showConfirmButton: false,
            timer: 1500
          });
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
        }
      },
      error => {
        ngswal("Failed!", error.error.Message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
    $("#LoadingImage").hide();
  }

  eptTrigger() {
    $("#LoadingImage").show();
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.eptApprove, aItemL).subscribe(
      resonse => {
        if (resonse.status.toLowerCase() == 'failed') {
          ngswal("Failed!", resonse.message, "warning");
        }
        else {
          ngswal({
            position: 'top-end',
            type: "success",
            title: resonse.message,
            showConfirmButton: false,
            timer: 1500
          });
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          if ($("#btnRefreshLoadData").length > 0) {
            $("#btnRefreshLoadData").trigger("click");
          }
        }
      },
      error => {
        ngswal("Failed!", error.error.Message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
    $("#LoadingImage").hide();
  }

  eptApprove() {
    ngswal({
      title: "Do you want to send the PDF to the author?",
      text: "Article EPT Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });

          $('#btnEPTApprove').trigger("click");

        } else {
          ngswal("Cancelled", "You clicked cancel! :)", "warning");
        }
      });
  }

  egApprove() {
    ngswal({
      title: "– Do you want to send the Proofing to the author?",
      text: "Article EG Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('#btnEGApprove').trigger("click");
        } else {
          ngswal("Cancelled", "You clicked cancel! :)", "warning");
        }
      });
  }

  static artId; static proofId; static activityId; static fileSno;

  hideAllocateModal(): void {
    $('#divAllocatePopup').hide();
  }

  static GetAllocateOption(artId, proofId, activityId, fileSNo): void {
    this.artId = artId; this.proofId = proofId; this.activityId = activityId; this.fileSno = fileSNo;
    if ((proofId == 10) || (proofId == 12) || (proofId == 15) || (proofId == 38) || (proofId == 35) || (proofId == 24) || (proofId == 57)
      || (proofId == 104) || (proofId == 20) || (proofId == 22)) {
      $('#divAllocatePopup').show();
    }
    else {
      ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadWfApi + '/' + artId + '/' + proofId + '/' + localStorage.aLoginID + '/0/' + fileSNo);
      ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
    }
  }

  downloadFile(): void {
    ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadWfApi + '/' + ArticleinfoComponent.artId + '/' + ArticleinfoComponent.proofId + '/' + localStorage.aLoginID + '/0');
  }

  UpdateAllocateUser(): void {
    var userID = $('#ddlAllocateUser').val();
    var aItemL = {
      AllocateUserId: userID,
      ArticleId: ArticleinfoComponent.articleId,
      ProofId: ArticleinfoComponent.proofId,
      ActivityId: ArticleinfoComponent.activityId
    }
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.updateAllocateApi, aItemL).subscribe(
      resonse => {
        if (resonse.status == 'Success') {
          ngswal("Updated!", resonse.message, "info");
          $('#divAllocatePopup').hide();

          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId, true);
          if ($("#btnRefreshLoadData").length > 0) {
            $("#btnRefreshLoadData").trigger("click");
          }
        }
        else {
          ngswal("Failed!", resonse.message, "warning");
        }
      },
      error => {
        ngswal("Failed!", error.error.Message, "warning");

      }
    );


  }

  HideReferenceNote() {
    $('#myModal_ReferenceNote').hide();
  }

  DownloadReferenceNoteFile(): void {
    ApiMethod.Downloadfile(ArticleinfoComponent.modelItem.downloadReferenceNote + '/' + localStorage.aEID + '/' + localStorage.ActivityId);
  }
  static PopulateReferenceNote(articleId, activityId) {

    $("#LoadingImagePopupRN").show();
    ApiMethod.getMethod(ArticleinfoComponent.modelItem.populateReferenceNote + '/' + articleId + '/' + activityId).subscribe(
      resonse => {
        $('#TxtInstructionRN').val(resonse.RefText);
        $('#arefDownload').html(resonse.RefFile);

        $("#LoadingImagePopupRN").hide();
        $('#myModal_ReferenceNote').show();
      },
      error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImagePopupRN").hide();
      }
    );
  }

  ReferenceNoteUpload() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_AttchmentRN')).files;
    if ((idInput.length == 0) && ($('#TxtInstructionRN').val().trim() == "")) {
      ngswal("Warning !", "Please enter instructions or upload a marked-up file to proceed with the Reference Data !", "warning");
    }
    else {
      $("#LoadingImagePopupRN").show();
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (idInput.length > 0) {
        file.fileName = idInput[0].name;
        file.fileSize = idInput[0].size;
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = "ReferenceType";
      file.id = localStorage.aEID;
      file.entryType = "";
      file.instruction = $('#TxtInstructionRN').val().trim();
      file.fileAsBase64 = this.fileBase64;
      file.ProcessId = localStorage.ActivityId;
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      ApiMethod.postMethod(ArticleinfoComponent.modelItem.referenceNoteUpload, file).subscribe(
        resonse => {
          $("#myModal_ReferenceNote").hide();
          if (resonse.status == "Failed") {
            ngswal({
              position: "top-end",
              type: "error",
              title: "Error!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
          $("#LoadingImagePopupRN").hide();
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopupRN").hide();
        }
      );

    }
  }

  //Change Special Issue Check Box
  ChangeSpecialIssue() {
    $("#chkIsSpecialToNormal").prop("disabled", true);
    if ($('#chkSIStatus').is(':checked')) {
      $("#chkIsSpecialToNormal").prop("disabled", false);
      $('#ddlSpecialIssue').val(1).change();
    }
    else {
      if ($('#chkIsSpecialToNormal').is(':checked')) {
        $('#chkIsSpecialToNormal').prop("checked", false);
        this.ChangeSpecialIssueTitle();
      }
      $('#ddlSpecialIssue').val(0).change();
    }
  }


  ChangeSpecialIssueTitle() {
    try {
      $('#ddlSpecialIssueTitle').val([]).trigger("change");
      const checkbox = $("#chkIsSpecialToNormal");
      const isChecked = checkbox.prop("checked");
      const parentElement = checkbox.parent();
      if (isChecked) {
        if (!$('#chkSIStatus').is(':checked')) {
          $('#chkSIStatus').prop("checked", true);
        }
        const dropdown = $("<select>")
          .attr("id", "SpecialIssueTitle")
          .attr("name", "changeSpecialIssueTitle")
          .css("width", "480px")
          .css("height", "25px");
        //Special Issue Title Load    
        const options = JSON.parse(localStorage.specialissuetitle);
        options.forEach(option => {
          dropdown.append($("<option>").attr("value", option.SpecialIssueTitle).text(option.SpecialIssueTitle));
        });

        let selectedValue;
        $('#ddlSpecialIssueTitle').empty();
        dropdown.on("change", function () {
          selectedValue = $(this).val();
          $('#ddlSpecialIssueTitle').append('<option value="' + selectedValue + '" selected>' + selectedValue + '</option>');
        });
        if ($('#SpecialIssueTitle').length == 0) {
          parentElement.append(dropdown);
        }
        //select2 
        $("#SpecialIssueTitle").select2({
          placeholder: "Select SI Title", dropdownParent: parentElement, tags: true
        });
        $("#SpecialIssueTitle").val([]).trigger("change");

        let siTitle = $("#chkIsSpecialToNormal").attr('data-sititle');
        if (siTitle != '') {
          $("#SpecialIssueTitle").val(siTitle).change();
        }
      }
      else {
        $(parentElement).find('.select2').remove();
      }

    } catch (e) {
      console.log('ChangeSpecialIssueTitle Function : ' + e);
    }

  }

  ProofingConfigPreview() {
    $("#LoadingImage").show();
    $('#divPreviewData').html('');
    ApiMethod.getMethod(ArticleinfoComponent.modelItem.ProofingConfigPreview + '/' + localStorage.aEID).subscribe(
      resonse => {
        if (resonse.Status) {
          let proofigData = resonse.DataItem;
          console.log(proofigData);
          let htmlData = '<table with="100%" cellpadding="5" cellspacing="5">';
          $.each(proofigData, function (e, val) {
            console.log(val);

            htmlData += '<tr>';
            if ($('#ddlProofingType').val() != 'EPDS') {
              htmlData += '<td><strong>Stage : ' + GlobalConstants.isNullCheck(val.Stage) + '</strong></td>';
              htmlData += '</tr>';
            }
            htmlData += '<tr>';
            htmlData += '<td><strong>From Name : ' + GlobalConstants.isNullCheck(val.FromName) + '</strong></td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td><strong>From Email : ' + GlobalConstants.isNullCheck(val.FromEmail) + '</strong></td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td><strong>To Name : ' + GlobalConstants.isNullCheck(val.ToName) + '</strong></td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td><strong>To Email : ' + GlobalConstants.isNullCheck(val.ToEmail) + '</strong></td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td><strong>Cc Email : ' + GlobalConstants.isNullCheck(val.CC) + '</strong></td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td><strong>Bcc Email : ' + GlobalConstants.isNullCheck(val.Bcc) + '</strong></td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td><strong>Subject</strong> : ' + GlobalConstants.isNullCheck(val.MailSubject) + '</td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td><strong>MailBody</strong><br/>' + GlobalConstants.isNullCheck(val.MailBody) + '</td>';
            htmlData += '</tr>';

            if (GlobalConstants.isNullCheck(val.ConfirmationMailBody) != '') {
              htmlData += '<tr>';
              htmlData += '<td>';
              htmlData += '<hr/><strong>Confirmation MailBody</strong><br/>';
              htmlData += GlobalConstants.isNullCheck(val.ConfirmationMailBody);
              htmlData += '</td>';
              htmlData += '</tr>';
            }

            htmlData += '<tr>';
            htmlData += '<td><hr/></td>';
            htmlData += '</tr>';

          });
          htmlData += '</table>';
          $('#divPreviewData').html(htmlData);
          $('#myModal_MailPreview').show();
        }
        else {
          $('#divPreviewData').html(resonse.Message);
          ngswal("warning", resonse.Message, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.Message, "warning");
      }
    );

  }

  OneMoreReviewSignalUpdate() {
    ngswal({
      title: "Do you want to request One More Review for the article?",
      text: "Article One more review request Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('#btnOneMoreReviewSignal').trigger("click");
        } else {
          ngswal("Cancelled", "You clicked cancel! :)", "warning");
        }
      });
  }
  static getUpdatedCID(): void {
    $("#LoadingImagePopup").show();
    var aItemCIDL = {
      Articleid: localStorage.aEID,
      Volume: $('#TxtPopVolume').val() == null ? "0" : $('#TxtPopVolume').val(),
      Issue: $('#TxtPopIssue').val() == null ? "0" : $('#TxtPopIssue').val(),
      Publishdate: $('#Txt_PublDate').val()
    }
    ApiMethod.postMethod(ArticleinfoComponent.modelItem.CIDNumberApi, aItemCIDL).subscribe(
      resonse => {
        let itemL = resonse.aTransItem;
        if ($('#TxtPopVolume').val() == '' || $('#TxtPopVolume').val() == '0')
          $('#TxtPopVolume').val(GlobalConstants.isNullCheck(itemL[0].Volume));
        if ($('#TxtPopIssue').val() == '' || $('#TxtPopIssue').val() == '0')
          $('#TxtPopIssue').val(GlobalConstants.isNullCheck(itemL[0].Issue));
        $('#TxtCID').val(GlobalConstants.isNullCheck(itemL[0].CID));
        $('#myModal_CID').show();
        $("#LoadingImagePopup").hide();
      },
      error => {
        ngswal("Failed!", error.error.Message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
  }


  GetCID() {
    ArticleinfoComponent.getUpdatedCID();
  }
  HideCIDModal() {
    $('#myModal_CID').hide();
  }
  HidePreviewModal() {
    $('#myModal_MailPreview').hide();
  }

  ApprovalFromJrlNotes() {
    ArticleinfoComponent.ArticleApproval();
  }

  HideJrlNotesModal() {
    $('#myModal_JrlNotes').hide();
  }

  HideStageDateChange() {
    $('#myModal_StageDateChange').hide();
  }

  UpdateCompletedDate() {

    if ($('#Txt_StageChangeDate').val() == '') {
      ngswal("warning", "Please Select Date", "warning");
    }
    else {
      var articleData = {
        PlanflowId: localStorage.planflowId,
        CompletedDate: $('#Txt_StageChangeDate').val(),
        UpdatedBy: localStorage.aLoginID,
      };
      ApiMethod.postMethod(ArticleinfoComponent.modelItem.ProjectPlanDateModify, articleData).subscribe(
        result => {
          if (result.Status == 'Success') {
            ngswal("Success", result.message, "success");
            $('#myModal_StageDateChange').hide();
          } else {
            ngswal("Failed !", result.message, "warning");
          }
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId, false, true);
        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
  }

  HidePubDateApproval() {
    $('#myModal_PubDate').hide();
  }


  ApproveWithPubDate() {
    if ($('#TxtPopEpubDate').val() == '') {
      ngswal("warning", "Please Select Date", "warning");
    }
    else {
      ArticleinfoComponent.ArticleApproval();
    }
  }

  HideApproveAttach() {
    $('#myModal_ApproveAttach').hide();
  }

  ChangeCorrXmlPdf() {
    let _type = $('#ddlCorrTypeXmlPdf').val();

    if (_type == 'Xml') {
      $('#divCorrTypeEpubDate').show();
    }
    else {
      $('#divCorrTypeEpubDate').hide();
    }
  }



  HideExpressCorrectionModal() {
    $('#myModal_ExpressCorrections').hide();
  }

  UpdateExpressCorrection() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_ECAttchment')).files;
    if ((idInput.length == 0) && ($('#TxtECInstruction').val().trim() == "")) {
      ngswal("Warning !", "Please enter instructions or upload a marked-up file to proceed with the correction !", "warning");
    }
    else {

      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (idInput.length > 0) {
        file.fileName = idInput[0].name;
        file.fileSize = idInput[0].size;
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.vendorConfigID = localStorage.aEID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = "Correction";
      file.id = localStorage.aEID;
      file.entryType = $("#ddlExpressCorrectionType").val();
      file.instruction = $('#TxtECInstruction').val().trim();
      file.dueDate = $('#Txt_DueDate').val();
      file.fileAsBase64 = this.fileBase64;

      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });

      ApiMethod.postMethod(ArticleinfoComponent.modelItem.uploadCorrectionApi, file).subscribe(
        resonse => {
          $("#myModal_ExpressCorrections").hide();
          if (resonse.status == "Failed") {
            ngswal({
              position: "top-end",
              type: "error",
              title: "Error!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
        },
        error => {
          ngswal("Failed !", error, "warning");
        }
      );

    }
  }

  HideExpressCorrectionUploadModal() {
    $('#myModal_ExpressCorrectionUpload').hide();
  }

  MsgCorrectionError: string;
  ExpressCorrectionUpload() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_ECUAttchment')).files;
    var UpElementExists = document.getElementById("FU_Attchment");

    if (idInput.length == 0) {
      this.MsgCorrectionError = 'Please Select upload file !'
    }
    else {
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (UpElementExists != null) {
        if (idInput.length > 0) {
          file.fileName = idInput[0].name;
          file.fileSize = idInput[0].size;
        }
        else {
          file.fileName = "";
          file.fileSize = 0;
        }
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.ArticleID = localStorage.aEID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.ProcessId = localStorage.ActivityId;
      file.entryType = localStorage.activity;
      file.id = localStorage.aEID;

      if (UpElementExists != null) {
        file.fileAsBase64 = this.fileBase64;
      }
      else {
        file.fileAsBase64 = "";
      }
      if (file.fileName.indexOf('.zip') == -1 && file.entryType == 'Graphics Correction') {
        this.MsgCorrectionError = 'Please Select zip file format !'
      }
      else if (file.fileName.indexOf('.xml') == -1 && file.entryType == 'Xml Correction') {
        this.MsgCorrectionError = 'Please Select xml file format !'
      }
      else {
        ngswal({
          title: 'Please wait processing!.....',
          text: '',
          showCancelButton: false,
          showConfirmButton: false
        });

        ApiMethod.postMethod(ArticleinfoComponent.modelItem.uploadExpressCorrection, file).subscribe(
          resonse => {
            let result = resonse;

            if (result.status) {
              $("#myModal_ExpressCorrectionUpload").hide();
              ngswal({
                position: "top-end",
                type: "success",
                title: "Uploaded!",
                text: result.message,
                showConfirmButton: false,
                timer: 1500
              });

              ArticleinfoComponent.ArticleInfo(ArticleinfoComponent.articleId);
            } else {
              ngswal("Failed !", result.message, "warning");
            }
          },
          error => {
            console.log(error);
          }
        );
        //$("#myModal_ExpressCorrectionUpload").hide();
        //ngswal("Info !", 'Upload Process stared...', "info");
      }

    }
  }

  HideManuscriptFileModal() {
    $('#myModal_ManuscriptFile').hide();
  }

  HideDelayModal() {
    $('#myModal_Delay').hide();
  }

  ApprovalFromDelay() {
    if ($('#TxtDelayReason').val() == "") {
      ngswal("Delay Reason", "Enter Delay Reason for this Article! :)", "warning");
    }
    else {
      ArticleinfoComponent.ArticleApproval();
    }
  }

  oniCodexFlexyPageFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {

      const filesList = Array.from(input.files);

      this.UploadFiles(filesList);

    }
  }

  UploadFiles(filesList: any) {
    $("#LoadingImage").show();
    const formData = new FormData();
    for (let i = 0; i < filesList.length; i++) {
      formData.append('files', filesList[i]);
    }
    formData.append("LoginId", localStorage.aLoginID);
    formData.append("ArticleId", localStorage.aEID);

    ApiMethod.postFileMethod1(`api/FlexyPageEditorFile`, formData).subscribe(
      resonse => {
        $("#LoadingImage").hide();
        let result = resonse;
        if (result.status) {
          ngswal("Uploaded !", result.message, "info");
        }
        else {
          ngswal("Failed !", result.message, "warning");
        }

      },
      error => {
        $("#LoadingImage").hide();
        console.log(error);
        ngswal("Failed !", error, "warning");
      }
    );

  }

  ShowArticleAction() {
    $('#ddlActionType').val('Select').change();
    $('#myModal_ArticleAction').show();
  }

  HideArticleAction() {
    $('#myModal_ArticleAction').hide();
  }

  UpdateArticleAction() {
    if ($('#ddlActionType').val().trim() == "Select") {
      ngswal("Warning !", "Please select action type !", "warning");
    }
    else {
      $("#LoadingImage").show();
      var articleData = {
        ArticleId: localStorage.aEID,
        ActionType: $('#ddlActionType').val(),
        LoginId: localStorage.aLoginID,
      };
      ApiMethod.postMethod('api/ArticleAction', articleData).subscribe(
        result => {
          $("#LoadingImage").hide();
          if (result.status == 'Success') {
            $('#myModal_ArticleAction').hide();
            ngswal("Success", result.message, "success");
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
          else {
            ngswal("Failed !", result.message, "warning");
          }
        },
        error => {
          $("#LoadingImage").show();
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
  }
}
